import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date; output: Date; }
};

export type AddCompanyRelationshipInput = {
  buildingId: Scalars['String']['input'];
  buildingName?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  companyReference?: InputMaybe<Scalars['String']['input']>;
  companyReferenceName?: InputMaybe<Scalars['String']['input']>;
  relationshipType: Scalars['String']['input'];
};

export type Address = {
  buildingId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstLine?: Maybe<Scalars['String']['output']>;
  gasRegion?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondLine?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstLine?: InputMaybe<Scalars['String']['input']>;
  gasRegion?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  secondLine?: InputMaybe<Scalars['String']['input']>;
};

export type Alert = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AlertCreateInput = {
  destination: Scalars['String']['input'];
  messageType: Scalars['String']['input'];
  severity: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
};

export type AlertDeleteInput = {
  id: Scalars['String']['input'];
};

export type AlertDeletePayload = {
  message: Scalars['String']['output'];
};

export type AlertGetManyInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AlertGetOneInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AlertUpdateInput = {
  id: Scalars['String']['input'];
  severity: Scalars['String']['input'];
};

export type AwsDataLakeConfig = {
  accessKey: Scalars['String']['output'];
  bucketName: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataLakeConfigType: Scalars['String']['output'];
  endpoint?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  period: Scalars['String']['output'];
  region: Scalars['String']['output'];
  roleArn?: Maybe<Scalars['String']['output']>;
  secretAccessKey: Scalars['String']['output'];
  session?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AwsDataLakeCreateInput = {
  accessKey: Scalars['String']['input'];
  bucketName: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  dataLakeConfigType: Scalars['String']['input'];
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSubscribed: Scalars['Boolean']['input'];
  isVerified: Scalars['Boolean']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  roleArn?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
};

export type AwsDataLakeUpdateInput = {
  accessKey?: InputMaybe<Scalars['String']['input']>;
  dataLakeConfigType: Scalars['String']['input'];
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  roleArn?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey?: InputMaybe<Scalars['String']['input']>;
  session?: InputMaybe<Scalars['String']['input']>;
};

export type Building = {
  address: Address;
  breeamRating: Scalars['String']['output'];
  breeamScore?: Maybe<Scalars['Float']['output']>;
  buildingTransmitting: Scalars['Boolean']['output'];
  channelIssues: Array<ChannelIssues>;
  companyRelationships: Array<CompanyRelationship>;
  constructionYear?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dashboardPeriod: Scalars['String']['output'];
  dashboardStyle: Scalars['String']['output'];
  defaultName: Scalars['String']['output'];
  epcRating?: Maybe<Scalars['String']['output']>;
  epcUrl?: Maybe<Scalars['String']['output']>;
  floorArea: Scalars['Float']['output'];
  hasDataServer: Scalars['Boolean']['output'];
  hasFileServer: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  infoMessage: Scalars['String']['output'];
  isOccupied: Scalars['Boolean']['output'];
  isSubscribedDatalake: Scalars['Boolean']['output'];
  isSubscribedOptitwin: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  mqttInfo: MqttAdminInfo;
  name: Scalars['String']['output'];
  picture: Scalars['String']['output'];
  portfolio: PortfolioTypes;
  projectRef: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
  tryMessage: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadConfig: BuildingUploadConfig;
};

export type BuildingCreateInput = {
  address: AddressInput;
  breeamScore?: InputMaybe<Scalars['Float']['input']>;
  companyId: Scalars['String']['input'];
  companyRelationshipType: Scalars['String']['input'];
  constructionYear?: InputMaybe<Scalars['Int']['input']>;
  dashboardStyle?: InputMaybe<Scalars['String']['input']>;
  defaultName: Scalars['String']['input'];
  epcRating: Scalars['String']['input'];
  epcUrl?: InputMaybe<Scalars['String']['input']>;
  floorArea: Scalars['Float']['input'];
  hasDataServer: Scalars['Boolean']['input'];
  hasFileServer: Scalars['Boolean']['input'];
  isOccupied: Scalars['Boolean']['input'];
  isSubscribedDatalake: Scalars['Boolean']['input'];
  isSubscribedOptitwin: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  picture: Scalars['String']['input'];
  projectRef: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  thumb: Scalars['String']['input'];
  uploadConfig: Array<BuildingUploadConfigCreateInput>;
};

export type BuildingDeleteInput = {
  id: Scalars['String']['input'];
};

export type BuildingDeletePayload = {
  message?: Maybe<Scalars['String']['output']>;
};

export type BuildingUpdateInput = {
  address?: InputMaybe<AddressInput>;
  breeamScore?: InputMaybe<Scalars['Float']['input']>;
  constructionYear?: InputMaybe<Scalars['Int']['input']>;
  defaultName?: InputMaybe<Scalars['String']['input']>;
  epcRating?: InputMaybe<Scalars['String']['input']>;
  epcUrl?: InputMaybe<Scalars['String']['input']>;
  floorArea?: InputMaybe<Scalars['Float']['input']>;
  hasDataServer?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileServer?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  isOccupied?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscribedDatalake?: InputMaybe<Scalars['Boolean']['input']>;
  isSubscribedOptitwin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  projectRef?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
  uploadConfig?: InputMaybe<Array<BuildingUploadConfigUpdateInput>>;
};

export type BuildingUploadConfig = {
  ftpConfig: Array<FtpConfig>;
  mqttConfig: Array<MqttConfig>;
};

export type BuildingUploadConfigCreateInput = {
  connectionType: Scalars['String']['input'];
  host?: InputMaybe<Scalars['String']['input']>;
  parser?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  useDefaultServer?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type BuildingUploadConfigUpdateInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  connectionType: Scalars['String']['input'];
  create?: InputMaybe<Scalars['Boolean']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  parser?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  useDefaultServer: Scalars['Boolean']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type BuildingWhereUniqueSearchManyInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  dataPeriod?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<DashboardUnitsInput>;
};

export type BuildingWhereUniqueSearchOneInput = {
  dataPeriod?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<DashboardUnitsInput>;
};

export type ChangePasswordResponse = {
  message: Scalars['String']['output'];
};

export type Channel = {
  buildingId?: Maybe<Scalars['String']['output']>;
  channelIssues?: Maybe<ChannelIssues>;
  channelType?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Channel>>;
  compositeChannelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  incomingUnit?: Maybe<Scalars['String']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  measurementType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadLabel?: Maybe<Scalars['String']['output']>;
};

export type ChannelCreateInput = {
  buildingId: Scalars['String']['input'];
  channelType?: InputMaybe<Scalars['String']['input']>;
  incomingUnit?: InputMaybe<Scalars['String']['input']>;
  measurementType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  period: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  uploadLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelIssues = {
  channelId?: Maybe<Scalars['String']['output']>;
  includesZeroes: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isImportant: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  notCumulative: Scalars['Boolean']['output'];
  notTransmitting: Scalars['Boolean']['output'];
};

export type ChannelSearchManyInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelSearchOneInput = {
  buildingId: Scalars['String']['input'];
  uploadLabel: Scalars['String']['input'];
};

export type ChannelUniqueIdInput = {
  channelId: Scalars['String']['input'];
};

export type ChannelUpdateInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
  channelType?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Array<ChannelUpdateInput>>;
  incomingUnit?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  measurementType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelUpdateManyInput = {
  ids: Array<Scalars['String']['input']>;
  incomingUnit?: InputMaybe<Scalars['String']['input']>;
  measurementType?: InputMaybe<Scalars['String']['input']>;
};

export type CheckAllDataInput = {
  channelType?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  measurementType?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckBuildingDataInput = {
  buildingId: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckChannelData = {
  message: Scalars['String']['output'];
};

export type CheckChannelDataInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CheckResetTokenResponse = {
  email: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
};

export type Company = {
  buildingRelationships: Array<CompanyRelationship>;
  createdAt: Scalars['DateTime']['output'];
  fontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  portfolioImage?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userIds: Array<Scalars['String']['output']>;
};

export type CompanyCreateInput = {
  fontColor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  portfolioImage?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CompanyDeleteInput = {
  id: Scalars['String']['input'];
};

export type CompanyDeletePayload = {
  message: Scalars['String']['output'];
};

export type CompanyRelationship = {
  buildingId: Scalars['String']['output'];
  buildingName: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  companyReference: Scalars['String']['output'];
  companyReferenceName: Scalars['String']['output'];
  relationshipType: Scalars['String']['output'];
};

export type CompanyRelationshipGetManyInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyRelationshipGetOneInput = {
  buildingId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};

export type CompanyUpdateInput = {
  fontColor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portfolioImage?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyWhereSearch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyWhereUnique = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CompositeChannel = {
  buildingId?: Maybe<Scalars['String']['output']>;
  channelList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  incomingUnit?: Maybe<Scalars['String']['output']>;
  isDashboardDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  shadowId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompositeChannelCreateInput = {
  buildingId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  period: Scalars['String']['input'];
};

export type CompositeChannelGetManyInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
};

export type CompositeChannelGetOneInput = {
  channelId: Scalars['String']['input'];
};

export type CompositeChannelUpdateInput = {
  channelId: Scalars['String']['input'];
  channelList?: InputMaybe<Array<Scalars['String']['input']>>;
  incomingUnit?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAwsInput = {
  accessKey: Scalars['String']['input'];
  bucketName: Scalars['String']['input'];
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSubscribed: Scalars['Boolean']['input'];
  isVerified: Scalars['Boolean']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  roleArn?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDataLakeInput = {
  awsParam?: InputMaybe<CreateAwsInput>;
  companyId: Scalars['String']['input'];
  dataLakeConfigType: Scalars['String']['input'];
  sftpParam?: InputMaybe<CreateSftpInput>;
};

export type CreateSftpInput = {
  host: Scalars['String']['input'];
  isSubscribed: Scalars['Boolean']['input'];
  passphrase?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  port: Scalars['Int']['input'];
  privateKey?: InputMaybe<Scalars['String']['input']>;
  remotePath?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type Dashboard = {
  address: Address;
  buildingId: Scalars['String']['output'];
  buildingName: Scalars['String']['output'];
  carbonDioxide: PortfolioTarget;
  coolingEnergy: PortfolioTarget;
  createdAt: Scalars['DateTime']['output'];
  currentConsumption: Scalars['Float']['output'];
  currentGeneration: Scalars['Float']['output'];
  dashboardColors: DashboardColors;
  dashboardStyle: Scalars['String']['output'];
  heatingEnergy: PortfolioTarget;
  id: Scalars['String']['output'];
  infoMessage: Scalars['String']['output'];
  lifetimeCarbonSavings: Scalars['Float']['output'];
  lifetimeCarbonSavingsUnits: Scalars['String']['output'];
  lightingEnergy: PortfolioTarget;
  occupierLogo: Scalars['String']['output'];
  period: Scalars['String']['output'];
  processEnergy: PortfolioTarget;
  renewables: PortfolioTarget;
  socketPower: PortfolioTarget;
  transportAPI: TransportApi;
  tryMessage: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  ventilation: PortfolioTarget;
  waterUsage: PortfolioTarget;
  weatherAPI: WeatherApi;
  wholeBuilding: PortfolioTarget;
};

export type DashboardColors = {
  fontColor: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  secondaryColor: Scalars['String']['output'];
};

export type DashboardInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  companySlug?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<DashboardUnitsInput>;
};

export type DashboardUnitsInput = {
  airQuality?: InputMaybe<Scalars['String']['input']>;
  amperage?: InputMaybe<Scalars['String']['input']>;
  boolean?: InputMaybe<Scalars['String']['input']>;
  combiCarbon?: InputMaybe<Scalars['String']['input']>;
  combiPower?: InputMaybe<Scalars['String']['input']>;
  electricity?: InputMaybe<Scalars['String']['input']>;
  gas?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['String']['input']>;
  unknown?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['String']['input']>;
  water?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardUpdateInput = {
  buildingId: Scalars['String']['input'];
  dashboardStyle?: InputMaybe<Scalars['String']['input']>;
  infoMessage?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  tryMessage?: InputMaybe<Scalars['String']['input']>;
};

export type Data = {
  data: Array<Datum>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type DataCreateInput = {
  data: Array<DatumCreateInput>;
};

export type DataInBins = {
  bins: Array<Datum>;
  date: Scalars['String']['output'];
};

export type DataInBinsInput = {
  channelId: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  maxCount?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type DataInput = {
  chanId: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  maxCount?: InputMaybe<Scalars['Int']['input']>;
  period: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type DataLakeBuildingConfig = {
  buildingId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  outgoingId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DataLakeBuildingCreateInput = {
  buildingId: Scalars['String']['input'];
  outgoingId: Scalars['String']['input'];
};

export type DataLakeBuildingDeleteInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DataLakeBuildingGetOneInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DataLakeChannelConfig = {
  channelId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  nonOperational: Scalars['Boolean']['output'];
  opFlagTime?: Maybe<Scalars['DateTime']['output']>;
  outgoingId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  utility?: Maybe<Scalars['String']['output']>;
};

export type DataLakeChannelCreateInput = {
  channelId: Scalars['String']['input'];
  nonOperational: Scalars['Boolean']['input'];
  opFlagTime: Scalars['DateTime']['input'];
  outgoingId: Scalars['String']['input'];
  utility: Scalars['String']['input'];
};

export type DataLakeChannelDeleteInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DataLakeChannelGetManyInput = {
  buildingId: Scalars['String']['input'];
};

export type DataLakeChannelGetOneInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DataLakeConfig = {
  aws: Array<AwsDataLakeConfig>;
  sftp: Array<SftpDataLakeConfig>;
};

export type DataLakeDeleteInput = {
  dataLakeConfigType: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type DataLakeDeletePayload = {
  message?: Maybe<Scalars['String']['output']>;
};

export type DataLakeGetAllInput = {
  companyId: Scalars['String']['input'];
  isSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataLakeUpdateInput = {
  accessKey?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  passphrase?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  remotePath?: InputMaybe<Scalars['String']['input']>;
  roleArn?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey?: InputMaybe<Scalars['String']['input']>;
  serviceConfigType: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Datum = {
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DatumCreateInput = {
  channelId: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  value: Scalars['Float']['input'];
};

export type DatumInput = {
  id: Scalars['String']['input'];
};

export type DeletePayload = {
  message?: Maybe<Scalars['String']['output']>;
};

export type ElectricityCarbon = {
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type ElectricityCarbonCreateInput = {
  country: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  value: Scalars['Float']['input'];
};

export type ElectricityCarbonDeleteInput = {
  id: Scalars['String']['input'];
};

export type EmailBuildingOverviewInput = {
  buildingId: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type EmailFullBuildingInput = {
  buildingId: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FileOutputReturn = {
  result?: Maybe<Scalars['String']['output']>;
};

export type FtpConfig = {
  buildingId?: Maybe<Scalars['String']['output']>;
  connectionType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  parser?: Maybe<Scalars['String']['output']>;
};

export type GasCalories = {
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  region: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type GasCaloriesCreateByUrlInput = {
  url: Scalars['String']['input'];
};

export type GasCaloriesCreateByUrlReturn = {
  message: Scalars['String']['output'];
};

export type GasCaloriesCreateInput = {
  country: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  region: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type GasCaloriesDeleteInput = {
  id: Scalars['String']['input'];
};

export type GasCarbon = {
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type GasCarbonCreateInput = {
  country: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  value: Scalars['Float']['input'];
};

export type GasCarbonDeleteInput = {
  id: Scalars['String']['input'];
};

export type GetAlertsByChannel = {
  benchmark?: Maybe<Scalars['Float']['output']>;
  channelId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  destination: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDashboardDefault: Scalars['Boolean']['output'];
  lastComparisonTime: Scalars['DateTime']['output'];
  lastComparisonValue: Scalars['Float']['output'];
  messageType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nextExpectedTime: Scalars['DateTime']['output'];
  period: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetValue?: Maybe<Scalars['Float']['output']>;
  triggerCondition: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type Inspector = {
  buildingId: Scalars['String']['output'];
  buildingLastSeen?: Maybe<Scalars['DateTime']['output']>;
  buildingTransmitting: Scalars['Boolean']['output'];
  channels: Array<ChannelIssues>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InspectorChannelUpdateOneInput = {
  channelId: Scalars['String']['input'];
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isImportant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InspectorGetOneInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  buildingSlug?: InputMaybe<Scalars['String']['input']>;
};

export type MeResponse = {
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MixedChannel = {
  children?: Maybe<Array<Maybe<MixedChannel>>>;
  composite?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDashboardDefault?: Maybe<Scalars['Boolean']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MixedChannelInput = {
  children: Array<MixedChannelInput>;
  composite: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  isDashboardDefault: Scalars['Boolean']['input'];
  isDisabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type MqttAdminInfo = {
  mqttPassword?: Maybe<Scalars['String']['output']>;
  mqttUsername?: Maybe<Scalars['String']['output']>;
};

export type MqttConfig = {
  buildingId?: Maybe<Scalars['String']['output']>;
  connectionType: Scalars['String']['output'];
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  useDefaultServer: Scalars['Boolean']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  addAwsDataLake: AwsDataLakeConfig;
  addCompanyRelationship?: Maybe<CompanyRelationship>;
  addDataLakeBuilding: DataLakeBuildingConfig;
  addDataLakeChannel: DataLakeChannelConfig;
  addSftpDataLake: SftpDataLakeConfig;
  addUploadConfig?: Maybe<UploadConfig>;
  alertCreate: Alert;
  alertDelete: AlertDeletePayload;
  alertUpdate: Alert;
  buildingCreate: Building;
  buildingDelete?: Maybe<BuildingDeletePayload>;
  buildingUpdate: Building;
  changePassword: ChangePasswordResponse;
  channelCreate: Channel;
  channelDelete: DeletePayload;
  channelRelationshipTreeUpdate: Array<Maybe<Channel>>;
  channelUpdate: Channel;
  channelUpdateMany: Array<Maybe<Channel>>;
  checkAllData: CheckChannelData;
  checkBuildingData: CheckChannelData;
  checkChannelData: CheckChannelData;
  companyCreate: Company;
  companyDelete: CompanyDeletePayload;
  companyUpdate: Company;
  compositeChannelCreate: CompositeChannel;
  compositeChannelRelationshipUpdate: Array<Maybe<MixedChannel>>;
  compositeChannelUpdate: CompositeChannel;
  dashboardUpdate: Dashboard;
  dataCreate: Array<Datum>;
  dataLakeCreate: DataLakeConfig;
  dataLakeDelete: DataLakeDeletePayload;
  dataLakeUpdate: DataLakeConfig;
  datumCreate: Array<Datum>;
  deleteDataLakeBuilding: DataLakeDeletePayload;
  deleteDataLakeChannel: DataLakeDeletePayload;
  electricityCarbonCreate: GasCarbon;
  electricityCarbonDelete: UnitDeleteReturn;
  gasCaloriesCreate: GasCalories;
  gasCaloriesCreateByUrl: GasCaloriesCreateByUrlReturn;
  gasCaloriesDelete: UnitDeleteReturn;
  gasCarbonCreate: GasCarbon;
  gasCarbonDelete: UnitDeleteReturn;
  inspectorChannelUpdateOne: ChannelIssues;
  removeCompanyRelationship?: Maybe<DeletePayload>;
  removeUploadConfig?: Maybe<DeletePayload>;
  reportingUpdate: ReportingReturn;
  resetFlag: ResetFlagReturn;
  /** @deprecated use sendResetPasswordEmail */
  resetPassword: ResetPasswordResponse;
  sendResetPasswordEmail: ResetPasswordResponse;
  setPassword: SetPasswordResponse;
  signIn: SignInResponse;
  signOut: SignOutResponse;
  targetAlertCreate: TargetAlert;
  targetAlertDelete: TargetAlertDeletePayload;
  targetAlertUpdate: Target;
  targetAlertUpdateMany: Array<Maybe<TargetAlert>>;
  targetCreate: Target;
  targetDelete: DeletePayload;
  targetRefresh: RefreshTargetReturn;
  targetUpdate: Target;
  updateAwsDataLake: AwsDataLakeConfig;
  updateCompanyRelationship?: Maybe<CompanyRelationship>;
  updateDataLakeBuilding: DataLakeBuildingConfig;
  updateDataLakeBuildings: Array<DataLakeBuildingConfig>;
  updateDataLakeChannel: DataLakeChannelConfig;
  updateDataLakeChannels: Array<DataLakeChannelConfig>;
  updateSftpDataLake: SftpDataLakeConfig;
  updateStyles: Styles;
  updateUploadConfig?: Maybe<UploadConfig>;
  userCreate: User;
  userDelete: UserDeletePayload;
  userUpdate: User;
};


export type MutationAddAwsDataLakeArgs = {
  data: AwsDataLakeCreateInput;
};


export type MutationAddCompanyRelationshipArgs = {
  data: AddCompanyRelationshipInput;
};


export type MutationAddDataLakeBuildingArgs = {
  data: DataLakeBuildingCreateInput;
};


export type MutationAddDataLakeChannelArgs = {
  data: DataLakeChannelCreateInput;
};


export type MutationAddSftpDataLakeArgs = {
  data: SftpDataLakeCreateInput;
};


export type MutationAddUploadConfigArgs = {
  data: UploadConfigInput;
};


export type MutationAlertCreateArgs = {
  where: AlertCreateInput;
};


export type MutationAlertDeleteArgs = {
  where: AlertDeleteInput;
};


export type MutationAlertUpdateArgs = {
  where: AlertUpdateInput;
};


export type MutationBuildingCreateArgs = {
  data: BuildingCreateInput;
};


export type MutationBuildingDeleteArgs = {
  data: BuildingDeleteInput;
};


export type MutationBuildingUpdateArgs = {
  data: BuildingUpdateInput;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationChannelCreateArgs = {
  data: ChannelCreateInput;
};


export type MutationChannelDeleteArgs = {
  data: ChannelUniqueIdInput;
};


export type MutationChannelRelationshipTreeUpdateArgs = {
  data: Array<ChannelUpdateInput>;
};


export type MutationChannelUpdateArgs = {
  data: ChannelUpdateInput;
};


export type MutationChannelUpdateManyArgs = {
  data: ChannelUpdateManyInput;
};


export type MutationCheckAllDataArgs = {
  data: CheckAllDataInput;
};


export type MutationCheckBuildingDataArgs = {
  data: CheckBuildingDataInput;
};


export type MutationCheckChannelDataArgs = {
  data: CheckChannelDataInput;
};


export type MutationCompanyCreateArgs = {
  data: CompanyCreateInput;
};


export type MutationCompanyDeleteArgs = {
  data: CompanyDeleteInput;
};


export type MutationCompanyUpdateArgs = {
  data: CompanyUpdateInput;
};


export type MutationCompositeChannelCreateArgs = {
  data: CompositeChannelCreateInput;
};


export type MutationCompositeChannelRelationshipUpdateArgs = {
  data: Array<MixedChannelInput>;
};


export type MutationCompositeChannelUpdateArgs = {
  data: CompositeChannelUpdateInput;
};


export type MutationDashboardUpdateArgs = {
  data: DashboardUpdateInput;
};


export type MutationDataCreateArgs = {
  data: DataCreateInput;
};


export type MutationDataLakeCreateArgs = {
  data: CreateDataLakeInput;
};


export type MutationDataLakeDeleteArgs = {
  data: DataLakeDeleteInput;
};


export type MutationDataLakeUpdateArgs = {
  data: DataLakeUpdateInput;
};


export type MutationDatumCreateArgs = {
  data: DatumCreateInput;
};


export type MutationDeleteDataLakeBuildingArgs = {
  data: DataLakeBuildingDeleteInput;
};


export type MutationDeleteDataLakeChannelArgs = {
  data: DataLakeChannelDeleteInput;
};


export type MutationElectricityCarbonCreateArgs = {
  data: ElectricityCarbonCreateInput;
};


export type MutationElectricityCarbonDeleteArgs = {
  data: ElectricityCarbonDeleteInput;
};


export type MutationGasCaloriesCreateArgs = {
  data: GasCaloriesCreateInput;
};


export type MutationGasCaloriesCreateByUrlArgs = {
  where: GasCaloriesCreateByUrlInput;
};


export type MutationGasCaloriesDeleteArgs = {
  data: GasCaloriesDeleteInput;
};


export type MutationGasCarbonCreateArgs = {
  data: GasCarbonCreateInput;
};


export type MutationGasCarbonDeleteArgs = {
  data: GasCarbonDeleteInput;
};


export type MutationInspectorChannelUpdateOneArgs = {
  where: InspectorChannelUpdateOneInput;
};


export type MutationRemoveCompanyRelationshipArgs = {
  data: RemoveCompanyRelationshipInput;
};


export type MutationRemoveUploadConfigArgs = {
  data: RemoveUploadCOnfigInput;
};


export type MutationReportingUpdateArgs = {
  data: ReportingUpdateInput;
};


export type MutationResetFlagArgs = {
  where: ResetFlagInput;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String']['input'];
  resetType: Scalars['String']['input'];
};


export type MutationSetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationTargetAlertCreateArgs = {
  data: TargetAlertCreateInput;
};


export type MutationTargetAlertDeleteArgs = {
  where: TargetAlertDeleteInput;
};


export type MutationTargetAlertUpdateArgs = {
  data: TargetAlertUpdate;
};


export type MutationTargetAlertUpdateManyArgs = {
  data: TargetAlertUpdateMany;
};


export type MutationTargetCreateArgs = {
  data: TargetCreateInput;
};


export type MutationTargetDeleteArgs = {
  data: TargetDeleteInput;
};


export type MutationTargetRefreshArgs = {
  targetId: Scalars['String']['input'];
};


export type MutationTargetUpdateArgs = {
  data: TargetUpdateInput;
};


export type MutationUpdateAwsDataLakeArgs = {
  data: AwsDataLakeUpdateInput;
};


export type MutationUpdateCompanyRelationshipArgs = {
  data: UpdateCompanyRelationshipInput;
};


export type MutationUpdateDataLakeBuildingArgs = {
  data: UpdateDataLakeBuildingInput;
};


export type MutationUpdateDataLakeBuildingsArgs = {
  data: Array<UpdateDataLakeBuildingInput>;
};


export type MutationUpdateDataLakeChannelArgs = {
  data: UpdateDataLakeChannelInput;
};


export type MutationUpdateDataLakeChannelsArgs = {
  data: Array<UpdateDataLakeChannelInput>;
};


export type MutationUpdateSftpDataLakeArgs = {
  data: SftpDataLakeUpdateInput;
};


export type MutationUpdateStylesArgs = {
  data: StylesUpdateInput;
};


export type MutationUpdateUploadConfigArgs = {
  data: UpdateUploadConifgInput;
};


export type MutationUserCreateArgs = {
  data: UserCreateInput;
};


export type MutationUserDeleteArgs = {
  data: UserDeleteInput;
};


export type MutationUserUpdateArgs = {
  data: UserChangeInput;
};

export type PeriodInputType = {
  alertId?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['String']['input'];
  targetValue?: InputMaybe<Scalars['Float']['input']>;
};

export type PeriodType = {
  alertId: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetValue?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioTarget = {
  comment: Scalars['String']['output'];
  comparison: Scalars['String']['output'];
  measurement: Scalars['Float']['output'];
  target: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type PortfolioTypes = {
  carbonDioxide: PortfolioTarget;
  coolingEnergy: PortfolioTarget;
  heatingEnergy: PortfolioTarget;
  lightingEnergy: PortfolioTarget;
  processEnergy: PortfolioTarget;
  renewables: PortfolioTarget;
  socketPower: PortfolioTarget;
  ventilation: PortfolioTarget;
  waterUsage: PortfolioTarget;
  wholeBuilding: PortfolioTarget;
};

export type Query = {
  alert: Alert;
  alerts: Array<Alert>;
  buildingGetMany: Array<Building>;
  buildingGetOne: Building;
  channelMeterRelationships: Array<Maybe<Channel>>;
  channelRetrieveUnique: Channel;
  channelSearchMany: Array<Maybe<Channel>>;
  channelSearchOne?: Maybe<Channel>;
  checkResetToken: CheckResetTokenResponse;
  companies: Array<Company>;
  company: Company;
  companyRelationshipGetMany: Array<CompanyRelationship>;
  companyRelationshipGetOne: CompanyRelationship;
  compositeChannelRelationships: Array<MixedChannel>;
  dashboard: Dashboard;
  /** @deprecated use dataGetMany */
  data: Array<Datum>;
  dataGetMany: Data;
  dataGetManyInBins: Array<DataInBins>;
  datum: Datum;
  electricityCarbonGetAll: Array<ElectricityCarbon>;
  emailBuildingOverview: FileOutputReturn;
  emailFullBuilding: FileOutputReturn;
  exportRebarReports: RebarReportResult;
  gasCaloriesGetAll: Array<GasCalories>;
  gasCarbonGetAll: Array<GasCarbon>;
  getAlertsByChannel: Array<GetAlertsByChannel>;
  getAllDataLakeConfigs: DataLakeConfig;
  getManyCompositeChannel: Array<Maybe<CompositeChannel>>;
  getManyDataLakeChannel: Array<Maybe<DataLakeChannelConfig>>;
  getOneCompositeChannel: CompositeChannel;
  getOneDataLakeBuilding: DataLakeBuildingConfig;
  getOneDataLakeChannel: DataLakeChannelConfig;
  inspectorGetOne: Inspector;
  me: MeResponse;
  styles: Styles;
  target: Target;
  targetAlertsGetMany: Array<Maybe<TargetAlert>>;
  targets: Array<Target>;
  userGetMany: Array<Maybe<User>>;
  userGetOne: User;
  verifyS3Credentials: VerificationCredentialsResult;
};


export type QueryAlertArgs = {
  where: AlertGetOneInput;
};


export type QueryAlertsArgs = {
  where: AlertGetManyInput;
};


export type QueryBuildingGetManyArgs = {
  where: BuildingWhereUniqueSearchManyInput;
};


export type QueryBuildingGetOneArgs = {
  where: BuildingWhereUniqueSearchOneInput;
};


export type QueryChannelMeterRelationshipsArgs = {
  where: SearchChannelByBuildingIdInput;
};


export type QueryChannelRetrieveUniqueArgs = {
  where: ChannelUniqueIdInput;
};


export type QueryChannelSearchManyArgs = {
  where: ChannelSearchManyInput;
};


export type QueryChannelSearchOneArgs = {
  where: ChannelSearchOneInput;
};


export type QueryCheckResetTokenArgs = {
  where: Scalars['String']['input'];
};


export type QueryCompaniesArgs = {
  where: CompanyWhereSearch;
};


export type QueryCompanyArgs = {
  where: CompanyWhereUnique;
};


export type QueryCompanyRelationshipGetManyArgs = {
  where: CompanyRelationshipGetManyInput;
};


export type QueryCompanyRelationshipGetOneArgs = {
  where: CompanyRelationshipGetOneInput;
};


export type QueryCompositeChannelRelationshipsArgs = {
  where: CompositeChannelGetManyInput;
};


export type QueryDashboardArgs = {
  where: DashboardInput;
};


export type QueryDataArgs = {
  where: DataInput;
};


export type QueryDataGetManyArgs = {
  where: DataInput;
};


export type QueryDataGetManyInBinsArgs = {
  where: DataInBinsInput;
};


export type QueryDatumArgs = {
  where: DatumInput;
};


export type QueryEmailBuildingOverviewArgs = {
  where: EmailBuildingOverviewInput;
};


export type QueryEmailFullBuildingArgs = {
  where: EmailFullBuildingInput;
};


export type QueryExportRebarReportsArgs = {
  where: RebarReportQueryInput;
};


export type QueryGetAlertsByChannelArgs = {
  channelId: Scalars['String']['input'];
};


export type QueryGetAllDataLakeConfigsArgs = {
  where: DataLakeGetAllInput;
};


export type QueryGetManyCompositeChannelArgs = {
  where: CompositeChannelGetManyInput;
};


export type QueryGetManyDataLakeChannelArgs = {
  where: DataLakeChannelGetManyInput;
};


export type QueryGetOneCompositeChannelArgs = {
  where: CompositeChannelGetOneInput;
};


export type QueryGetOneDataLakeBuildingArgs = {
  where: DataLakeBuildingGetOneInput;
};


export type QueryGetOneDataLakeChannelArgs = {
  where: DataLakeChannelGetOneInput;
};


export type QueryInspectorGetOneArgs = {
  where: InspectorGetOneInput;
};


export type QueryStylesArgs = {
  where: StylesWhereUnique;
};


export type QueryTargetArgs = {
  where: TargetGetOneInput;
};


export type QueryTargetAlertsGetManyArgs = {
  where: TargetGetManyInput;
};


export type QueryTargetsArgs = {
  where: TargetGetManyInput;
};


export type QueryUserGetManyArgs = {
  where: UserGetManyInput;
};


export type QueryUserGetOneArgs = {
  where: UserGetOneInput;
};


export type QueryVerifyS3CredentialsArgs = {
  where: AwsDataLakeCreateInput;
};

export type RebarReportQueryInput = {
  buildings: Array<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RebarReportResult = {
  filePath?: Maybe<Scalars['String']['output']>;
};

export type RefreshTargetReturn = {
  message: Scalars['String']['output'];
};

export type RemoveCompanyRelationshipInput = {
  buildingId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};

export type RemoveUploadCOnfigInput = {
  antonioBuildingId: Scalars['String']['input'];
  saratogaBuildingId: Scalars['String']['input'];
};

export type Reporting = {
  buildings: Array<ReportingBuilding>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  portfolioEnabled: Scalars['Boolean']['output'];
  portfolioPeriod: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type ReportingBuilding = {
  buildingEnabled: Scalars['Boolean']['output'];
  buildingId: Scalars['String']['output'];
  buildingName: Scalars['String']['output'];
  buildingPeriod: Scalars['String']['output'];
};

export type ReportingReturn = {
  result: Scalars['String']['output'];
};

export type ReportingUpdateBuildingInput = {
  buildingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  buildingId: Scalars['String']['input'];
  buildingPeriod?: InputMaybe<Scalars['String']['input']>;
};

export type ReportingUpdateInput = {
  buildings: Array<ReportingUpdateBuildingInput>;
  portfolioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioPeriod?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ResendSetPasswordEmailResponse = {
  message: Scalars['String']['output'];
};

export type ResetFlagInput = {
  channelId: Scalars['String']['input'];
  flag: Scalars['String']['input'];
};

export type ResetFlagReturn = {
  message: Scalars['String']['output'];
};

export type ResetPasswordResponse = {
  message: Scalars['String']['output'];
};

export type SearchChannelByBuildingIdInput = {
  buildingId: Scalars['String']['input'];
};

export type SetPasswordResponse = {
  message: Scalars['String']['output'];
};

export type SftpDataLakeConfig = {
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataLakeConfigType: Scalars['String']['output'];
  host: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  passphrase?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  period: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  privateKey?: Maybe<Scalars['String']['output']>;
  remotePath?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type SftpDataLakeCreateInput = {
  companyId: Scalars['String']['input'];
  dataLakeConfigType: Scalars['String']['input'];
  host: Scalars['String']['input'];
  passphrase?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  port: Scalars['Int']['input'];
  privateKey?: InputMaybe<Scalars['String']['input']>;
  remotePath?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type SftpDataLakeUpdateInput = {
  dataLakeConfigType: Scalars['String']['input'];
  host?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  passphrase?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  remotePath?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SignInResponse = {
  message: Scalars['String']['output'];
  token: Scalars['String']['output'];
  user?: Maybe<SignInUser>;
};

export type SignInUser = {
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customPermissions: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SignOutResponse = {
  message: Scalars['String']['output'];
};

export type Styles = {
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  portfolioImage?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StylesCreateInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  fontColor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  portfolioImage?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type StylesUpdateInput = {
  companyId: Scalars['String']['input'];
  fontColor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  portfolioImage?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type StylesWhereUnique = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type Target = {
  benchmark?: Maybe<Scalars['Float']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDashboardDefault?: Maybe<Scalars['Boolean']['output']>;
  lastComparisonTime?: Maybe<Scalars['DateTime']['output']>;
  lastComparisonValue?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextExpectedTime?: Maybe<Scalars['DateTime']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  targetValue?: Maybe<Scalars['Float']['output']>;
  triggerCondition?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TargetAlert = {
  benchmark?: Maybe<Scalars['Float']['output']>;
  channelId: Scalars['String']['output'];
  daily: PeriodType;
  isDashboardDefault: Scalars['Boolean']['output'];
  monthly: PeriodType;
  name: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  triggerCondition: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  weekly: PeriodType;
  yearly: PeriodType;
};

export type TargetAlertCreateInput = {
  benchmark?: InputMaybe<Scalars['Float']['input']>;
  channelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  triggerCondition: Scalars['String']['input'];
};

export type TargetAlertDeleteInput = {
  targetIds: Array<Scalars['String']['input']>;
};

export type TargetAlertDeletePayload = {
  message: Scalars['String']['output'];
};

export type TargetAlertUpdate = {
  id: Scalars['String']['input'];
  targetValue?: InputMaybe<Scalars['Float']['input']>;
};

export type TargetCreateInput = {
  benchmark?: InputMaybe<Scalars['Float']['input']>;
  channelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  period: Scalars['String']['input'];
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  triggerCondition: Scalars['String']['input'];
};

export type TargetDeleteInput = {
  id: Scalars['String']['input'];
};

export type TargetGetManyInput = {
  channelId: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type TargetGetOneInput = {
  id: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type TargetUpdateInput = {
  benchmark?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  triggerCondition?: InputMaybe<Scalars['String']['input']>;
};

export type TransportApi = {
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type UnitDeleteReturn = {
  message: Scalars['String']['output'];
};

export type UpdateCompanyRelationshipInput = {
  buildingId: Scalars['String']['input'];
  buildingName?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  companyReference?: InputMaybe<Scalars['String']['input']>;
  companyReferenceName?: InputMaybe<Scalars['String']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDataLakeBuildingInput = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  outgoingId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDataLakeChannelInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nonOperational?: InputMaybe<Scalars['Boolean']['input']>;
  outgoingId?: InputMaybe<Scalars['String']['input']>;
  utility?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUploadConifgInput = {
  antonioBuildingId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  saratogaBuildingId?: InputMaybe<Scalars['String']['input']>;
};

export type UploadConfig = {
  antonioBuildingId: Scalars['String']['output'];
  buildingId: Scalars['String']['output'];
};

export type UploadConfigInput = {
  antonioBuildingId: Scalars['String']['input'];
  saratogaBuildingId: Scalars['String']['input'];
};

export type User = {
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customPermissions?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  reporting: Reporting;
  role?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserChangeInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateInput = {
  companyId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type UserDeleteInput = {
  id: Scalars['String']['input'];
};

export type UserDeletePayload = {
  message?: Maybe<Scalars['String']['output']>;
};

export type UserGetManyInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UserGetOneInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UserWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type WeatherApi = {
  host: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type TargetAlertUpdateMany = {
  name?: InputMaybe<Scalars['String']['input']>;
  targetIds: Array<Scalars['String']['input']>;
  triggerCondition?: InputMaybe<Scalars['String']['input']>;
};

export type VerificationCredentialsResult = {
  message?: Maybe<Scalars['String']['output']>;
};

export type ChannelRelationshipTreeUpdateMutationVariables = Exact<{
  data: Array<ChannelUpdateInput> | ChannelUpdateInput;
}>;


export type ChannelRelationshipTreeUpdateMutation = { channelRelationshipTreeUpdate: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, uploadLabel?: string | null, reference?: string | null, period?: string | null, incomingUnit?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null, children?: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, uploadLabel?: string | null, reference?: string | null, period?: string | null, incomingUnit?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null, children?: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, uploadLabel?: string | null, reference?: string | null, period?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null }> | null }> | null } | null> };

export type CompositeChannelCreateMutationVariables = Exact<{
  data: CompositeChannelCreateInput;
}>;


export type CompositeChannelCreateMutation = { compositeChannelCreate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, buildingId?: string | null, channelList?: Array<string | null> | null, period?: string | null, shadowId?: string | null, isDashboardDefault?: boolean | null, incomingUnit?: string | null } };

export type CompositeChannelUpdateMutationVariables = Exact<{
  data: CompositeChannelUpdateInput;
}>;


export type CompositeChannelUpdateMutation = { compositeChannelUpdate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, buildingId?: string | null, channelList?: Array<string | null> | null, period?: string | null, shadowId?: string | null, isDashboardDefault?: boolean | null, incomingUnit?: string | null } };

export type ChannelCreateMutationVariables = Exact<{
  data: ChannelCreateInput;
}>;


export type ChannelCreateMutation = { channelCreate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, uploadLabel?: string | null, reference?: string | null, period?: string | null, incomingUnit?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null } };

export type CompositeChannelRelationshipUpdateMutationVariables = Exact<{
  data: Array<MixedChannelInput> | MixedChannelInput;
}>;


export type CompositeChannelRelationshipUpdateMutation = { compositeChannelRelationshipUpdate: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null } | null> | null } | null> | null } | null> | null } | null> | null } | null> | null } | null> };

export type UserUpdateMutationVariables = Exact<{
  data: UserChangeInput;
}>;


export type UserUpdateMutation = { userUpdate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, companyId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null, picture?: string | null, role?: string | null, customPermissions?: string | null } };

export type CompanyUpdateMutationVariables = Exact<{
  data: CompanyUpdateInput;
}>;


export type CompanyUpdateMutation = { companyUpdate: { id: string, createdAt: Date, updatedAt: Date, name: string, slug: string, portfolioImage?: string | null, logo?: string | null, primaryColor?: string | null, secondaryColor?: string | null, fontColor?: string | null, userIds: Array<string> } };

export type ChannelUpdateMutationVariables = Exact<{
  data: ChannelUpdateInput;
}>;


export type ChannelUpdateMutation = { channelUpdate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, uploadLabel?: string | null, reference?: string | null, period?: string | null, incomingUnit?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null } };

export type DeleteUserMutationVariables = Exact<{
  data: UserDeleteInput;
}>;


export type DeleteUserMutation = { userDelete: { message?: string | null } };

export type DeleteCompanyMutationVariables = Exact<{
  data: CompanyDeleteInput;
}>;


export type DeleteCompanyMutation = { companyDelete: { message: string } };

export type ChannelDeleteMutationVariables = Exact<{
  data: ChannelUniqueIdInput;
}>;


export type ChannelDeleteMutation = { channelDelete: { message?: string | null } };

export type TargetCreateMutationVariables = Exact<{
  data: TargetCreateInput;
}>;


export type TargetCreateMutation = { targetCreate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, period?: string | null, benchmark?: number | null, channelId?: string | null, targetValue?: number | null, triggerCondition?: string | null, nextExpectedTime?: Date | null, lastComparisonTime?: Date | null, lastComparisonValue?: number | null } };

export type TargetDeleteMutationVariables = Exact<{
  data: TargetDeleteInput;
}>;


export type TargetDeleteMutation = { targetDelete: { message?: string | null } };

export type TargetUpdateMutationVariables = Exact<{
  data: TargetUpdateInput;
}>;


export type TargetUpdateMutation = { targetUpdate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, period?: string | null, benchmark?: number | null, channelId?: string | null, targetValue?: number | null, triggerCondition?: string | null, nextExpectedTime?: Date | null, lastComparisonTime?: Date | null, lastComparisonValue?: number | null } };

export type AlertCreateMutationVariables = Exact<{
  where: AlertCreateInput;
}>;


export type AlertCreateMutation = { alertCreate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, destination?: string | null, messageType?: string | null, severity?: string | null } };

export type AlertUpdateMutationVariables = Exact<{
  where: AlertUpdateInput;
}>;


export type AlertUpdateMutation = { alertUpdate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, destination?: string | null, messageType?: string | null, severity?: string | null } };

export type AlertDeleteMutationVariables = Exact<{
  where: AlertDeleteInput;
}>;


export type AlertDeleteMutation = { alertDelete: { message: string } };

export type SendResetPasswordEmailMutationVariables = Exact<{
  resetType: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type SendResetPasswordEmailMutation = { sendResetPasswordEmail: { message: string } };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { setPassword: { message: string } };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { changePassword: { message: string } };

export type BuildingCreateMutationVariables = Exact<{
  data: BuildingCreateInput;
}>;


export type BuildingCreateMutation = { buildingCreate: { id: string, createdAt: Date, updatedAt: Date, name: string, defaultName: string, projectRef: string, slug: string, picture: string, thumb: string, epcRating?: string | null, epcUrl?: string | null, floorArea: number, hasFileServer: boolean, hasDataServer: boolean, dashboardPeriod: string, dashboardStyle: string, lastSeen?: Date | null, buildingTransmitting: boolean, isOccupied: boolean, isSubscribedDatalake: boolean, isSubscribedOptitwin: boolean, mqttInfo: { mqttUsername?: string | null, mqttPassword?: string | null }, uploadConfig: { ftpConfig: Array<{ id: string, buildingId?: string | null, connectionType: string, parser?: string | null }>, mqttConfig: Array<{ id: string, buildingId?: string | null, connectionType: string, host?: string | null, password?: string | null, port?: number | null, protocol?: string | null, topic?: string | null, useDefaultServer: boolean, username?: string | null }> } } };

export type BuildingUpdateMutationVariables = Exact<{
  data: BuildingUpdateInput;
}>;


export type BuildingUpdateMutation = { buildingUpdate: { id: string, createdAt: Date, updatedAt: Date, name: string, defaultName: string, projectRef: string, slug: string, picture: string, thumb: string, epcRating?: string | null, epcUrl?: string | null, floorArea: number, hasFileServer: boolean, hasDataServer: boolean, dashboardPeriod: string, dashboardStyle: string, lastSeen?: Date | null, buildingTransmitting: boolean, breeamScore?: number | null, isOccupied: boolean, isSubscribedDatalake: boolean, isSubscribedOptitwin: boolean, mqttInfo: { mqttUsername?: string | null, mqttPassword?: string | null }, uploadConfig: { ftpConfig: Array<{ id: string, buildingId?: string | null, connectionType: string, parser?: string | null }>, mqttConfig: Array<{ id: string, buildingId?: string | null, connectionType: string, host?: string | null, password?: string | null, port?: number | null, protocol?: string | null, topic?: string | null, useDefaultServer: boolean, username?: string | null }> } } };

export type BuildingDeleteMutationVariables = Exact<{
  data: BuildingDeleteInput;
}>;


export type BuildingDeleteMutation = { buildingDelete?: { message?: string | null } | null };

export type DashboardUpdateMutationVariables = Exact<{
  data: DashboardUpdateInput;
}>;


export type DashboardUpdateMutation = { dashboardUpdate: { id: string, period: string, tryMessage: string, infoMessage: string } };

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SignInMutation = { signIn: { token: string, message: string, user?: { id: string, firstName: string, lastName: string, slug: string, picture?: string | null, isStaff: boolean, isAdmin: boolean, companyId: string } | null } };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { signOut: { message: string } };

export type CreateCompanyMutationVariables = Exact<{
  data: CompanyCreateInput;
}>;


export type CreateCompanyMutation = { companyCreate: { id: string, createdAt: Date, updatedAt: Date, name: string, slug: string, portfolioImage?: string | null, logo?: string | null, userIds: Array<string> } };

export type UserCreateMutationVariables = Exact<{
  data: UserCreateInput;
}>;


export type UserCreateMutation = { userCreate: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, companyId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null, picture?: string | null, role?: string | null, customPermissions?: string | null } };

export type AddCompanyRelationshipMutationVariables = Exact<{
  data: AddCompanyRelationshipInput;
}>;


export type AddCompanyRelationshipMutation = { addCompanyRelationship?: { buildingId: string, companyId: string, companyName: string, buildingName: string, companyReference: string, companyReferenceName: string, relationshipType: string } | null };

export type RemoveCompanyRelationshipMutationVariables = Exact<{
  data: RemoveCompanyRelationshipInput;
}>;


export type RemoveCompanyRelationshipMutation = { removeCompanyRelationship?: { message?: string | null } | null };

export type UpdateCompanyRelationshipMutationVariables = Exact<{
  data: UpdateCompanyRelationshipInput;
}>;


export type UpdateCompanyRelationshipMutation = { updateCompanyRelationship?: { companyId: string, buildingId: string, companyName: string, buildingName: string, companyReference: string, companyReferenceName: string, relationshipType: string } | null };

export type ResetFlagMutationVariables = Exact<{
  where: ResetFlagInput;
}>;


export type ResetFlagMutation = { resetFlag: { message: string } };

export type InspectorChannelUpdateOneMutationVariables = Exact<{
  where: InspectorChannelUpdateOneInput;
}>;


export type InspectorChannelUpdateOneMutation = { inspectorChannelUpdateOne: { channelId?: string | null, lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } };

export type TargetAlertUpdateMutationVariables = Exact<{
  data: TargetAlertUpdate;
}>;


export type TargetAlertUpdateMutation = { targetAlertUpdate: { name?: string | null, benchmark?: number | null, channelId?: string | null, triggerCondition?: string | null, isDashboardDefault?: boolean | null } };

export type TargetAlertUpdateManyMutationVariables = Exact<{
  data: TargetAlertUpdateMany;
}>;


export type TargetAlertUpdateManyMutation = { targetAlertUpdateMany: Array<{ name: string, benchmark?: number | null, channelId: string, triggerCondition: string, isDashboardDefault: boolean, severity: string, daily: { targetId: string, targetValue?: number | null, alertId: string }, weekly: { targetId: string, targetValue?: number | null, alertId: string }, monthly: { targetId: string, targetValue?: number | null, alertId: string }, yearly: { targetId: string, targetValue?: number | null, alertId: string } } | null> };

export type TargetAlertDeleteMutationVariables = Exact<{
  where: TargetAlertDeleteInput;
}>;


export type TargetAlertDeleteMutation = { targetAlertDelete: { message: string } };

export type CheckChannelDataMutationVariables = Exact<{
  data: CheckChannelDataInput;
}>;


export type CheckChannelDataMutation = { checkChannelData: { message: string } };

export type CheckBuildingDataMutationVariables = Exact<{
  data: CheckBuildingDataInput;
}>;


export type CheckBuildingDataMutation = { checkBuildingData: { message: string } };

export type CheckAllDataMutationVariables = Exact<{
  data: CheckAllDataInput;
}>;


export type CheckAllDataMutation = { checkAllData: { message: string } };

export type TargetAlertCreateMutationVariables = Exact<{
  data: TargetAlertCreateInput;
}>;


export type TargetAlertCreateMutation = { targetAlertCreate: { name: string, benchmark?: number | null, channelId: string, triggerCondition: string, isDashboardDefault: boolean, severity: string, daily: { targetId: string, targetValue?: number | null, alertId: string }, weekly: { targetId: string, targetValue?: number | null, alertId: string }, monthly: { targetId: string, targetValue?: number | null, alertId: string }, yearly: { targetId: string, targetValue?: number | null, alertId: string } } };

export type ChannelUpdateManyMutationVariables = Exact<{
  data: ChannelUpdateManyInput;
}>;


export type ChannelUpdateManyMutation = { channelUpdateMany: Array<{ id?: string | null, name?: string | null, measurementType?: string | null } | null> };

export type GasCaloriesCreateByUrlMutationVariables = Exact<{
  where: GasCaloriesCreateByUrlInput;
}>;


export type GasCaloriesCreateByUrlMutation = { gasCaloriesCreateByUrl: { message: string } };

export type GasCaloriesCreateMutationVariables = Exact<{
  data: GasCaloriesCreateInput;
}>;


export type GasCaloriesCreateMutation = { gasCaloriesCreate: { id: string, country: string, date: Date, value: number } };

export type GasCarbonCreateMutationVariables = Exact<{
  data: GasCarbonCreateInput;
}>;


export type GasCarbonCreateMutation = { gasCarbonCreate: { id: string, country: string, date: Date, value: number } };

export type ElectricityCarbonCreateMutationVariables = Exact<{
  data: ElectricityCarbonCreateInput;
}>;


export type ElectricityCarbonCreateMutation = { electricityCarbonCreate: { id: string, country: string, date: Date, value: number } };

export type GasCaloriesDeleteMutationVariables = Exact<{
  data: GasCaloriesDeleteInput;
}>;


export type GasCaloriesDeleteMutation = { gasCaloriesDelete: { message: string } };

export type GasCarbonDeleteMutationVariables = Exact<{
  data: GasCarbonDeleteInput;
}>;


export type GasCarbonDeleteMutation = { gasCarbonDelete: { message: string } };

export type ElectricityCarbonDeleteMutationVariables = Exact<{
  data: ElectricityCarbonDeleteInput;
}>;


export type ElectricityCarbonDeleteMutation = { electricityCarbonDelete: { message: string } };

export type AccountUpdateMutationVariables = Exact<{
  data: UserChangeInput;
}>;


export type AccountUpdateMutation = { userUpdate: { id?: string | null, email?: string | null } };

export type ReportingUpdateMutationVariables = Exact<{
  data: ReportingUpdateInput;
}>;


export type ReportingUpdateMutation = { reportingUpdate: { result: string } };

export type BuildingGetIdQueryVariables = Exact<{
  where: BuildingWhereUniqueSearchOneInput;
}>;


export type BuildingGetIdQuery = { buildingGetOne: { id: string, name: string } };

export type ChannelSearchManyQueryVariables = Exact<{
  where: ChannelSearchManyInput;
}>;


export type ChannelSearchManyQuery = { channelSearchMany: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, reference?: string | null, period?: string | null, incomingUnit?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, isDisabled?: boolean | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null } | null> };

export type CompositeChannelRelationshipsQueryVariables = Exact<{
  where: CompositeChannelGetManyInput;
}>;


export type CompositeChannelRelationshipsQuery = { compositeChannelRelationships: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null, children?: Array<{ name?: string | null, id?: string | null, composite?: boolean | null, isDashboardDefault?: boolean | null } | null> | null } | null> | null } | null> | null } | null> | null } | null> | null }> };

export type ChannelMeterRelationshipsQueryVariables = Exact<{
  where: SearchChannelByBuildingIdInput;
}>;


export type ChannelMeterRelationshipsQuery = { channelMeterRelationships: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, reference?: string | null, period?: string | null, incomingUnit?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null, children?: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, reference?: string | null, period?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null, children?: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, reference?: string | null, period?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null, children?: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, reference?: string | null, period?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null, children?: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, reference?: string | null, period?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null, children?: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, reference?: string | null, period?: string | null, measurementType?: string | null, buildingId?: string | null, parentId?: string | null, channelType?: string | null, channelIssues?: { lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean } | null }> | null }> | null }> | null }> | null }> | null } | null> };

export type GetOneCompositeChannelQueryVariables = Exact<{
  where: CompositeChannelGetOneInput;
}>;


export type GetOneCompositeChannelQuery = { getOneCompositeChannel: { id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, buildingId?: string | null, channelList?: Array<string | null> | null, period?: string | null, shadowId?: string | null, isDashboardDefault?: boolean | null, incomingUnit?: string | null } };

export type TargetsQueryVariables = Exact<{
  where: TargetGetManyInput;
}>;


export type TargetsQuery = { targets: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, period?: string | null, benchmark?: number | null, channelId?: string | null, targetValue?: number | null, triggerCondition?: string | null, nextExpectedTime?: Date | null, lastComparisonTime?: Date | null, lastComparisonValue?: number | null }> };

export type AlertsQueryVariables = Exact<{
  where: AlertGetManyInput;
}>;


export type AlertsQuery = { alerts: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, userId?: string | null, targetId?: string | null, destination?: string | null, messageType?: string | null, severity?: string | null }> };

export type BuildingGetManyQueryVariables = Exact<{
  where: BuildingWhereUniqueSearchManyInput;
}>;


export type BuildingGetManyQuery = { buildingGetMany: Array<{ id: string, name: string, defaultName: string, projectRef: string, slug: string, picture: string, thumb: string, epcRating?: string | null, epcUrl?: string | null, breeamRating: string, breeamScore?: number | null, constructionYear?: number | null, floorArea: number, hasFileServer: boolean, hasDataServer: boolean, dashboardPeriod: string, dashboardStyle: string, lastSeen?: Date | null, buildingTransmitting: boolean, isOccupied: boolean, isSubscribedDatalake: boolean, isSubscribedOptitwin: boolean, channelIssues: Array<{ channelId?: string | null, lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean }>, mqttInfo: { mqttUsername?: string | null, mqttPassword?: string | null }, uploadConfig: { ftpConfig: Array<{ id: string, buildingId?: string | null, connectionType: string, parser?: string | null }>, mqttConfig: Array<{ id: string, buildingId?: string | null, connectionType: string, host?: string | null, password?: string | null, port?: number | null, protocol?: string | null, topic?: string | null, useDefaultServer: boolean, username?: string | null }> }, companyRelationships: Array<{ companyId: string, companyName: string, buildingName: string, companyReference: string, companyReferenceName: string, relationshipType: string }>, address: { buildingId?: string | null, companyId?: string | null, firstLine?: string | null, secondLine?: string | null, city?: string | null, region?: string | null, country?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null, gasRegion?: string | null }, portfolio: { renewables: { measurement: number, target: number, unit: string }, waterUsage: { measurement: number, target: number, unit: string }, carbonDioxide: { measurement: number, target: number, unit: string }, wholeBuilding: { measurement: number, target: number, unit: string } } }> };

export type CompanyQueryVariables = Exact<{
  where: CompanyWhereUnique;
}>;


export type CompanyQuery = { company: { name: string, portfolioImage?: string | null, slug: string, logo?: string | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { token?: string | null } };

export type CheckResetTokenQueryVariables = Exact<{
  where: Scalars['String']['input'];
}>;


export type CheckResetTokenQuery = { checkResetToken: { isValid: boolean, email: string } };

export type BuildingGetOneQueryVariables = Exact<{
  where: BuildingWhereUniqueSearchOneInput;
}>;


export type BuildingGetOneQuery = { buildingGetOne: { id: string, name: string, defaultName: string, projectRef: string, slug: string, picture: string, thumb: string, epcRating?: string | null, epcUrl?: string | null, breeamRating: string, breeamScore?: number | null, constructionYear?: number | null, floorArea: number, hasFileServer: boolean, hasDataServer: boolean, dashboardPeriod: string, dashboardStyle: string, lastSeen?: Date | null, buildingTransmitting: boolean, tryMessage: string, infoMessage: string, isOccupied: boolean, isSubscribedDatalake: boolean, isSubscribedOptitwin: boolean, channelIssues: Array<{ channelId?: string | null, lastSeen?: Date | null, isImportant: boolean, notTransmitting: boolean, notCumulative: boolean, includesZeroes: boolean, isDisabled: boolean }>, mqttInfo: { mqttUsername?: string | null, mqttPassword?: string | null }, uploadConfig: { ftpConfig: Array<{ id: string, buildingId?: string | null, connectionType: string, parser?: string | null }>, mqttConfig: Array<{ id: string, buildingId?: string | null, connectionType: string, host?: string | null, password?: string | null, port?: number | null, protocol?: string | null, topic?: string | null, useDefaultServer: boolean, username?: string | null }> }, companyRelationships: Array<{ companyId: string, buildingId: string, companyName: string, buildingName: string, companyReference: string, companyReferenceName: string, relationshipType: string }>, address: { buildingId?: string | null, companyId?: string | null, firstLine?: string | null, secondLine?: string | null, city?: string | null, region?: string | null, country?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null, gasRegion?: string | null }, portfolio: { renewables: { measurement: number, target: number, comment: string, comparison: string, unit: string }, waterUsage: { measurement: number, target: number, comment: string, comparison: string, unit: string }, carbonDioxide: { measurement: number, target: number, comment: string, comparison: string, unit: string }, wholeBuilding: { measurement: number, target: number, comment: string, comparison: string, unit: string }, heatingEnergy: { measurement: number, target: number, comment: string, comparison: string, unit: string }, coolingEnergy: { measurement: number, target: number, comment: string, comparison: string, unit: string }, processEnergy: { measurement: number, target: number, comment: string, comparison: string, unit: string }, socketPower: { measurement: number, target: number, comment: string, comparison: string, unit: string }, lightingEnergy: { measurement: number, target: number, comment: string, comparison: string, unit: string }, ventilation: { measurement: number, target: number, comment: string, comparison: string, unit: string } } } };

export type CompaniesQueryVariables = Exact<{
  where: CompanyWhereSearch;
}>;


export type CompaniesQuery = { companies: Array<{ id: string, createdAt: Date, updatedAt: Date, name: string, slug: string, portfolioImage?: string | null, logo?: string | null, primaryColor?: string | null, secondaryColor?: string | null, fontColor?: string | null, userIds: Array<string> }> };

export type DataGetManyQueryVariables = Exact<{
  where: DataInput;
}>;


export type DataGetManyQuery = { dataGetMany: { id: string, name: string, unit: string, data: Array<{ id?: string | null, channelId?: string | null, timestamp?: Date | null, value?: number | null, status?: string | null }> } };

export type DashboardQueryVariables = Exact<{
  where: DashboardInput;
}>;


export type DashboardQuery = { dashboard: { id: string, createdAt: Date, updatedAt: Date, buildingId: string, buildingName: string, occupierLogo: string, dashboardStyle: string, period: string, tryMessage: string, infoMessage: string, currentConsumption: number, currentGeneration: number, lifetimeCarbonSavings: number, lifetimeCarbonSavingsUnits: string, renewables: { measurement: number, target: number, comment: string, comparison: string, unit: string }, carbonDioxide: { measurement: number, target: number, comment: string, comparison: string, unit: string }, waterUsage: { measurement: number, target: number, comment: string, comparison: string, unit: string }, wholeBuilding: { measurement: number, target: number, comment: string, comparison: string, unit: string }, ventilation: { measurement: number, target: number, comment: string, comparison: string, unit: string }, coolingEnergy: { measurement: number, target: number, comment: string, comparison: string, unit: string }, heatingEnergy: { measurement: number, target: number, comment: string, comparison: string, unit: string }, lightingEnergy: { measurement: number, target: number, comment: string, comparison: string, unit: string }, socketPower: { measurement: number, target: number, comment: string, comparison: string, unit: string }, processEnergy: { measurement: number, target: number, comment: string, comparison: string, unit: string }, dashboardColors: { primaryColor: string, secondaryColor: string, fontColor: string }, address: { companyId?: string | null, city?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null }, weatherAPI: { key: string, host: string }, transportAPI: { id: string, key: string } } };

export type UserGetManyQueryVariables = Exact<{
  where: UserGetManyInput;
}>;


export type UserGetManyQuery = { userGetMany: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, companyId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null, picture?: string | null, role?: string | null, customPermissions?: string | null } | null> };

export type CompanyListQueryVariables = Exact<{
  where: CompanyWhereSearch;
}>;


export type CompanyListQuery = { companies: Array<{ id: string, name: string }> };

export type EmailBuildingOverviewQueryVariables = Exact<{
  where: EmailBuildingOverviewInput;
}>;


export type EmailBuildingOverviewQuery = { emailBuildingOverview: { result?: string | null } };

export type EmailFullBuildingQueryVariables = Exact<{
  where: EmailFullBuildingInput;
}>;


export type EmailFullBuildingQuery = { emailFullBuilding: { result?: string | null } };

export type GetManyCompositeChannelQueryVariables = Exact<{
  where: CompositeChannelGetManyInput;
}>;


export type GetManyCompositeChannelQuery = { getManyCompositeChannel: Array<{ id?: string | null, createdAt?: Date | null, updatedAt?: Date | null, name?: string | null, buildingId?: string | null, channelList?: Array<string | null> | null, period?: string | null, shadowId?: string | null, incomingUnit?: string | null } | null> };

export type InspectorGetOneQueryVariables = Exact<{
  where: InspectorGetOneInput;
}>;


export type InspectorGetOneQuery = { inspectorGetOne: { id: string, createdAt: Date, updatedAt: Date, buildingId: string, buildingLastSeen?: Date | null, buildingTransmitting: boolean, channels: Array<{ lastSeen?: Date | null, channelId?: string | null, isImportant: boolean, notCumulative: boolean, includesZeroes: boolean, notTransmitting: boolean, isDisabled: boolean }> } };

export type TargetAlertsGetManyQueryVariables = Exact<{
  where: TargetGetManyInput;
}>;


export type TargetAlertsGetManyQuery = { targetAlertsGetMany: Array<{ name: string, benchmark?: number | null, channelId: string, triggerCondition: string, isDashboardDefault: boolean, severity: string, daily: { targetId: string, targetValue?: number | null, alertId: string }, weekly: { targetId: string, targetValue?: number | null, alertId: string }, monthly: { targetId: string, targetValue?: number | null, alertId: string }, yearly: { targetId: string, targetValue?: number | null, alertId: string } } | null> };

export type GasCaloriesGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GasCaloriesGetAllQuery = { gasCaloriesGetAll: Array<{ id: string, country: string, region: string, date: Date, value: number }> };

export type GasCarbonGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GasCarbonGetAllQuery = { gasCarbonGetAll: Array<{ id: string, country: string, date: Date, value: number }> };

export type ElectricityCarbonGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type ElectricityCarbonGetAllQuery = { electricityCarbonGetAll: Array<{ id: string, country: string, date: Date, value: number }> };

export type DataGetManyInBinsQueryVariables = Exact<{
  where: DataInBinsInput;
}>;


export type DataGetManyInBinsQuery = { dataGetManyInBins: Array<{ date: string, bins: Array<{ id?: string | null, timestamp?: Date | null, value?: number | null, status?: string | null, channelId?: string | null }> }> };

export type BuildingGetAddressQueryVariables = Exact<{
  where: BuildingWhereUniqueSearchManyInput;
}>;


export type BuildingGetAddressQuery = { buildingGetMany: Array<{ id: string, name: string, address: { buildingId?: string | null, postcode?: string | null, latitude?: number | null, longitude?: number | null } }> };

export type UserGetOneQueryVariables = Exact<{
  where: UserGetOneInput;
}>;


export type UserGetOneQuery = { userGetOne: { email?: string | null, firstName?: string | null, lastName?: string | null, picture?: string | null, id?: string | null, reporting: { id: string, userId: string, portfolioEnabled: boolean, portfolioPeriod: string, buildings: Array<{ buildingId: string, buildingName: string, buildingEnabled: boolean, buildingPeriod: string }> } } };


export const ChannelRelationshipTreeUpdateDocument = gql`
    mutation ChannelRelationshipTreeUpdate($data: [ChannelUpdateInput!]!) {
  channelRelationshipTreeUpdate(data: $data) {
    id
    createdAt
    updatedAt
    name
    uploadLabel
    reference
    period
    incomingUnit
    measurementType
    buildingId
    parentId
    channelType
    channelIssues {
      lastSeen
      isImportant
      notTransmitting
      notCumulative
      includesZeroes
      isDisabled
    }
    children {
      id
      createdAt
      updatedAt
      name
      uploadLabel
      reference
      period
      incomingUnit
      measurementType
      buildingId
      parentId
      channelType
      channelIssues {
        lastSeen
        isImportant
        notTransmitting
        notCumulative
        includesZeroes
        isDisabled
      }
      children {
        id
        createdAt
        updatedAt
        name
        uploadLabel
        reference
        period
        measurementType
        buildingId
        parentId
        channelType
        channelIssues {
          lastSeen
          isImportant
          notTransmitting
          notCumulative
          includesZeroes
          isDisabled
        }
      }
    }
  }
}
    `;
export type ChannelRelationshipTreeUpdateMutationFn = Apollo.MutationFunction<ChannelRelationshipTreeUpdateMutation, ChannelRelationshipTreeUpdateMutationVariables>;

/**
 * __useChannelRelationshipTreeUpdateMutation__
 *
 * To run a mutation, you first call `useChannelRelationshipTreeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChannelRelationshipTreeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [channelRelationshipTreeUpdateMutation, { data, loading, error }] = useChannelRelationshipTreeUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChannelRelationshipTreeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ChannelRelationshipTreeUpdateMutation, ChannelRelationshipTreeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChannelRelationshipTreeUpdateMutation, ChannelRelationshipTreeUpdateMutationVariables>(ChannelRelationshipTreeUpdateDocument, options);
      }
export type ChannelRelationshipTreeUpdateMutationHookResult = ReturnType<typeof useChannelRelationshipTreeUpdateMutation>;
export type ChannelRelationshipTreeUpdateMutationResult = Apollo.MutationResult<ChannelRelationshipTreeUpdateMutation>;
export type ChannelRelationshipTreeUpdateMutationOptions = Apollo.BaseMutationOptions<ChannelRelationshipTreeUpdateMutation, ChannelRelationshipTreeUpdateMutationVariables>;
export const CompositeChannelCreateDocument = gql`
    mutation CompositeChannelCreate($data: CompositeChannelCreateInput!) {
  compositeChannelCreate(data: $data) {
    id
    createdAt
    updatedAt
    name
    buildingId
    channelList
    period
    shadowId
    isDashboardDefault
    incomingUnit
  }
}
    `;
export type CompositeChannelCreateMutationFn = Apollo.MutationFunction<CompositeChannelCreateMutation, CompositeChannelCreateMutationVariables>;

/**
 * __useCompositeChannelCreateMutation__
 *
 * To run a mutation, you first call `useCompositeChannelCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompositeChannelCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [compositeChannelCreateMutation, { data, loading, error }] = useCompositeChannelCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCompositeChannelCreateMutation(baseOptions?: Apollo.MutationHookOptions<CompositeChannelCreateMutation, CompositeChannelCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompositeChannelCreateMutation, CompositeChannelCreateMutationVariables>(CompositeChannelCreateDocument, options);
      }
export type CompositeChannelCreateMutationHookResult = ReturnType<typeof useCompositeChannelCreateMutation>;
export type CompositeChannelCreateMutationResult = Apollo.MutationResult<CompositeChannelCreateMutation>;
export type CompositeChannelCreateMutationOptions = Apollo.BaseMutationOptions<CompositeChannelCreateMutation, CompositeChannelCreateMutationVariables>;
export const CompositeChannelUpdateDocument = gql`
    mutation CompositeChannelUpdate($data: CompositeChannelUpdateInput!) {
  compositeChannelUpdate(data: $data) {
    id
    createdAt
    updatedAt
    name
    buildingId
    channelList
    period
    shadowId
    isDashboardDefault
    incomingUnit
  }
}
    `;
export type CompositeChannelUpdateMutationFn = Apollo.MutationFunction<CompositeChannelUpdateMutation, CompositeChannelUpdateMutationVariables>;

/**
 * __useCompositeChannelUpdateMutation__
 *
 * To run a mutation, you first call `useCompositeChannelUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompositeChannelUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [compositeChannelUpdateMutation, { data, loading, error }] = useCompositeChannelUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCompositeChannelUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompositeChannelUpdateMutation, CompositeChannelUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompositeChannelUpdateMutation, CompositeChannelUpdateMutationVariables>(CompositeChannelUpdateDocument, options);
      }
export type CompositeChannelUpdateMutationHookResult = ReturnType<typeof useCompositeChannelUpdateMutation>;
export type CompositeChannelUpdateMutationResult = Apollo.MutationResult<CompositeChannelUpdateMutation>;
export type CompositeChannelUpdateMutationOptions = Apollo.BaseMutationOptions<CompositeChannelUpdateMutation, CompositeChannelUpdateMutationVariables>;
export const ChannelCreateDocument = gql`
    mutation ChannelCreate($data: ChannelCreateInput!) {
  channelCreate(data: $data) {
    id
    createdAt
    updatedAt
    name
    uploadLabel
    reference
    period
    incomingUnit
    measurementType
    buildingId
    parentId
    channelType
  }
}
    `;
export type ChannelCreateMutationFn = Apollo.MutationFunction<ChannelCreateMutation, ChannelCreateMutationVariables>;

/**
 * __useChannelCreateMutation__
 *
 * To run a mutation, you first call `useChannelCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChannelCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [channelCreateMutation, { data, loading, error }] = useChannelCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChannelCreateMutation(baseOptions?: Apollo.MutationHookOptions<ChannelCreateMutation, ChannelCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChannelCreateMutation, ChannelCreateMutationVariables>(ChannelCreateDocument, options);
      }
export type ChannelCreateMutationHookResult = ReturnType<typeof useChannelCreateMutation>;
export type ChannelCreateMutationResult = Apollo.MutationResult<ChannelCreateMutation>;
export type ChannelCreateMutationOptions = Apollo.BaseMutationOptions<ChannelCreateMutation, ChannelCreateMutationVariables>;
export const CompositeChannelRelationshipUpdateDocument = gql`
    mutation CompositeChannelRelationshipUpdate($data: [MixedChannelInput!]!) {
  compositeChannelRelationshipUpdate(data: $data) {
    name
    id
    composite
    isDashboardDefault
    children {
      name
      id
      composite
      isDashboardDefault
      children {
        name
        id
        composite
        isDashboardDefault
        children {
          name
          id
          composite
          isDashboardDefault
          children {
            name
            id
            composite
            isDashboardDefault
            children {
              name
              id
              composite
              isDashboardDefault
            }
          }
        }
      }
    }
  }
}
    `;
export type CompositeChannelRelationshipUpdateMutationFn = Apollo.MutationFunction<CompositeChannelRelationshipUpdateMutation, CompositeChannelRelationshipUpdateMutationVariables>;

/**
 * __useCompositeChannelRelationshipUpdateMutation__
 *
 * To run a mutation, you first call `useCompositeChannelRelationshipUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompositeChannelRelationshipUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [compositeChannelRelationshipUpdateMutation, { data, loading, error }] = useCompositeChannelRelationshipUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCompositeChannelRelationshipUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompositeChannelRelationshipUpdateMutation, CompositeChannelRelationshipUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompositeChannelRelationshipUpdateMutation, CompositeChannelRelationshipUpdateMutationVariables>(CompositeChannelRelationshipUpdateDocument, options);
      }
export type CompositeChannelRelationshipUpdateMutationHookResult = ReturnType<typeof useCompositeChannelRelationshipUpdateMutation>;
export type CompositeChannelRelationshipUpdateMutationResult = Apollo.MutationResult<CompositeChannelRelationshipUpdateMutation>;
export type CompositeChannelRelationshipUpdateMutationOptions = Apollo.BaseMutationOptions<CompositeChannelRelationshipUpdateMutation, CompositeChannelRelationshipUpdateMutationVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($data: UserChangeInput!) {
  userUpdate(data: $data) {
    id
    createdAt
    updatedAt
    companyId
    email
    firstName
    lastName
    slug
    picture
    role
    customPermissions
  }
}
    `;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const CompanyUpdateDocument = gql`
    mutation CompanyUpdate($data: CompanyUpdateInput!) {
  companyUpdate(data: $data) {
    id
    createdAt
    updatedAt
    name
    slug
    portfolioImage
    logo
    primaryColor
    secondaryColor
    fontColor
    userIds
  }
}
    `;
export type CompanyUpdateMutationFn = Apollo.MutationFunction<CompanyUpdateMutation, CompanyUpdateMutationVariables>;

/**
 * __useCompanyUpdateMutation__
 *
 * To run a mutation, you first call `useCompanyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdateMutation, { data, loading, error }] = useCompanyUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCompanyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyUpdateMutation, CompanyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyUpdateMutation, CompanyUpdateMutationVariables>(CompanyUpdateDocument, options);
      }
export type CompanyUpdateMutationHookResult = ReturnType<typeof useCompanyUpdateMutation>;
export type CompanyUpdateMutationResult = Apollo.MutationResult<CompanyUpdateMutation>;
export type CompanyUpdateMutationOptions = Apollo.BaseMutationOptions<CompanyUpdateMutation, CompanyUpdateMutationVariables>;
export const ChannelUpdateDocument = gql`
    mutation ChannelUpdate($data: ChannelUpdateInput!) {
  channelUpdate(data: $data) {
    id
    createdAt
    updatedAt
    name
    uploadLabel
    reference
    period
    incomingUnit
    measurementType
    buildingId
    parentId
    channelType
    channelIssues {
      lastSeen
      isImportant
      notTransmitting
      notCumulative
      includesZeroes
      isDisabled
    }
  }
}
    `;
export type ChannelUpdateMutationFn = Apollo.MutationFunction<ChannelUpdateMutation, ChannelUpdateMutationVariables>;

/**
 * __useChannelUpdateMutation__
 *
 * To run a mutation, you first call `useChannelUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChannelUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [channelUpdateMutation, { data, loading, error }] = useChannelUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChannelUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ChannelUpdateMutation, ChannelUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChannelUpdateMutation, ChannelUpdateMutationVariables>(ChannelUpdateDocument, options);
      }
export type ChannelUpdateMutationHookResult = ReturnType<typeof useChannelUpdateMutation>;
export type ChannelUpdateMutationResult = Apollo.MutationResult<ChannelUpdateMutation>;
export type ChannelUpdateMutationOptions = Apollo.BaseMutationOptions<ChannelUpdateMutation, ChannelUpdateMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($data: UserDeleteInput!) {
  userDelete(data: $data) {
    message
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation deleteCompany($data: CompanyDeleteInput!) {
  companyDelete(data: $data) {
    message
  }
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const ChannelDeleteDocument = gql`
    mutation ChannelDelete($data: ChannelUniqueIdInput!) {
  channelDelete(data: $data) {
    message
  }
}
    `;
export type ChannelDeleteMutationFn = Apollo.MutationFunction<ChannelDeleteMutation, ChannelDeleteMutationVariables>;

/**
 * __useChannelDeleteMutation__
 *
 * To run a mutation, you first call `useChannelDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChannelDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [channelDeleteMutation, { data, loading, error }] = useChannelDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChannelDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ChannelDeleteMutation, ChannelDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChannelDeleteMutation, ChannelDeleteMutationVariables>(ChannelDeleteDocument, options);
      }
export type ChannelDeleteMutationHookResult = ReturnType<typeof useChannelDeleteMutation>;
export type ChannelDeleteMutationResult = Apollo.MutationResult<ChannelDeleteMutation>;
export type ChannelDeleteMutationOptions = Apollo.BaseMutationOptions<ChannelDeleteMutation, ChannelDeleteMutationVariables>;
export const TargetCreateDocument = gql`
    mutation TargetCreate($data: TargetCreateInput!) {
  targetCreate(data: $data) {
    id
    createdAt
    updatedAt
    name
    period
    benchmark
    channelId
    targetValue
    triggerCondition
    nextExpectedTime
    lastComparisonTime
    lastComparisonValue
  }
}
    `;
export type TargetCreateMutationFn = Apollo.MutationFunction<TargetCreateMutation, TargetCreateMutationVariables>;

/**
 * __useTargetCreateMutation__
 *
 * To run a mutation, you first call `useTargetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTargetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [targetCreateMutation, { data, loading, error }] = useTargetCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTargetCreateMutation(baseOptions?: Apollo.MutationHookOptions<TargetCreateMutation, TargetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TargetCreateMutation, TargetCreateMutationVariables>(TargetCreateDocument, options);
      }
export type TargetCreateMutationHookResult = ReturnType<typeof useTargetCreateMutation>;
export type TargetCreateMutationResult = Apollo.MutationResult<TargetCreateMutation>;
export type TargetCreateMutationOptions = Apollo.BaseMutationOptions<TargetCreateMutation, TargetCreateMutationVariables>;
export const TargetDeleteDocument = gql`
    mutation TargetDelete($data: TargetDeleteInput!) {
  targetDelete(data: $data) {
    message
  }
}
    `;
export type TargetDeleteMutationFn = Apollo.MutationFunction<TargetDeleteMutation, TargetDeleteMutationVariables>;

/**
 * __useTargetDeleteMutation__
 *
 * To run a mutation, you first call `useTargetDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTargetDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [targetDeleteMutation, { data, loading, error }] = useTargetDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTargetDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TargetDeleteMutation, TargetDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TargetDeleteMutation, TargetDeleteMutationVariables>(TargetDeleteDocument, options);
      }
export type TargetDeleteMutationHookResult = ReturnType<typeof useTargetDeleteMutation>;
export type TargetDeleteMutationResult = Apollo.MutationResult<TargetDeleteMutation>;
export type TargetDeleteMutationOptions = Apollo.BaseMutationOptions<TargetDeleteMutation, TargetDeleteMutationVariables>;
export const TargetUpdateDocument = gql`
    mutation TargetUpdate($data: TargetUpdateInput!) {
  targetUpdate(data: $data) {
    id
    createdAt
    updatedAt
    name
    period
    benchmark
    channelId
    targetValue
    triggerCondition
    nextExpectedTime
    lastComparisonTime
    lastComparisonValue
  }
}
    `;
export type TargetUpdateMutationFn = Apollo.MutationFunction<TargetUpdateMutation, TargetUpdateMutationVariables>;

/**
 * __useTargetUpdateMutation__
 *
 * To run a mutation, you first call `useTargetUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTargetUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [targetUpdateMutation, { data, loading, error }] = useTargetUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTargetUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TargetUpdateMutation, TargetUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TargetUpdateMutation, TargetUpdateMutationVariables>(TargetUpdateDocument, options);
      }
export type TargetUpdateMutationHookResult = ReturnType<typeof useTargetUpdateMutation>;
export type TargetUpdateMutationResult = Apollo.MutationResult<TargetUpdateMutation>;
export type TargetUpdateMutationOptions = Apollo.BaseMutationOptions<TargetUpdateMutation, TargetUpdateMutationVariables>;
export const AlertCreateDocument = gql`
    mutation AlertCreate($where: AlertCreateInput!) {
  alertCreate(where: $where) {
    id
    createdAt
    updatedAt
    id
    destination
    messageType
    severity
  }
}
    `;
export type AlertCreateMutationFn = Apollo.MutationFunction<AlertCreateMutation, AlertCreateMutationVariables>;

/**
 * __useAlertCreateMutation__
 *
 * To run a mutation, you first call `useAlertCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlertCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alertCreateMutation, { data, loading, error }] = useAlertCreateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAlertCreateMutation(baseOptions?: Apollo.MutationHookOptions<AlertCreateMutation, AlertCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlertCreateMutation, AlertCreateMutationVariables>(AlertCreateDocument, options);
      }
export type AlertCreateMutationHookResult = ReturnType<typeof useAlertCreateMutation>;
export type AlertCreateMutationResult = Apollo.MutationResult<AlertCreateMutation>;
export type AlertCreateMutationOptions = Apollo.BaseMutationOptions<AlertCreateMutation, AlertCreateMutationVariables>;
export const AlertUpdateDocument = gql`
    mutation AlertUpdate($where: AlertUpdateInput!) {
  alertUpdate(where: $where) {
    id
    createdAt
    updatedAt
    id
    destination
    messageType
    severity
  }
}
    `;
export type AlertUpdateMutationFn = Apollo.MutationFunction<AlertUpdateMutation, AlertUpdateMutationVariables>;

/**
 * __useAlertUpdateMutation__
 *
 * To run a mutation, you first call `useAlertUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlertUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alertUpdateMutation, { data, loading, error }] = useAlertUpdateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAlertUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AlertUpdateMutation, AlertUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlertUpdateMutation, AlertUpdateMutationVariables>(AlertUpdateDocument, options);
      }
export type AlertUpdateMutationHookResult = ReturnType<typeof useAlertUpdateMutation>;
export type AlertUpdateMutationResult = Apollo.MutationResult<AlertUpdateMutation>;
export type AlertUpdateMutationOptions = Apollo.BaseMutationOptions<AlertUpdateMutation, AlertUpdateMutationVariables>;
export const AlertDeleteDocument = gql`
    mutation AlertDelete($where: AlertDeleteInput!) {
  alertDelete(where: $where) {
    message
  }
}
    `;
export type AlertDeleteMutationFn = Apollo.MutationFunction<AlertDeleteMutation, AlertDeleteMutationVariables>;

/**
 * __useAlertDeleteMutation__
 *
 * To run a mutation, you first call `useAlertDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlertDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alertDeleteMutation, { data, loading, error }] = useAlertDeleteMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAlertDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AlertDeleteMutation, AlertDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlertDeleteMutation, AlertDeleteMutationVariables>(AlertDeleteDocument, options);
      }
export type AlertDeleteMutationHookResult = ReturnType<typeof useAlertDeleteMutation>;
export type AlertDeleteMutationResult = Apollo.MutationResult<AlertDeleteMutation>;
export type AlertDeleteMutationOptions = Apollo.BaseMutationOptions<AlertDeleteMutation, AlertDeleteMutationVariables>;
export const SendResetPasswordEmailDocument = gql`
    mutation SendResetPasswordEmail($resetType: String!, $email: String!) {
  sendResetPasswordEmail(resetType: $resetType, email: $email) {
    message
  }
}
    `;
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *      resetType: // value for 'resetType'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>(SendResetPasswordEmailDocument, options);
      }
export type SendResetPasswordEmailMutationHookResult = ReturnType<typeof useSendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationResult = Apollo.MutationResult<SendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($password: String!, $token: String!) {
  setPassword(password: $password, token: $token) {
    message
  }
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    message
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const BuildingCreateDocument = gql`
    mutation BuildingCreate($data: BuildingCreateInput!) {
  buildingCreate(data: $data) {
    id
    createdAt
    updatedAt
    name
    defaultName
    projectRef
    slug
    picture
    thumb
    epcRating
    epcUrl
    floorArea
    hasFileServer
    hasDataServer
    dashboardPeriod
    dashboardStyle
    lastSeen
    buildingTransmitting
    isOccupied
    isSubscribedDatalake
    isSubscribedOptitwin
    mqttInfo {
      mqttUsername
      mqttPassword
    }
    uploadConfig {
      ftpConfig {
        id
        buildingId
        connectionType
        parser
      }
      mqttConfig {
        id
        buildingId
        connectionType
        host
        password
        port
        protocol
        topic
        useDefaultServer
        username
      }
    }
  }
}
    `;
export type BuildingCreateMutationFn = Apollo.MutationFunction<BuildingCreateMutation, BuildingCreateMutationVariables>;

/**
 * __useBuildingCreateMutation__
 *
 * To run a mutation, you first call `useBuildingCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingCreateMutation, { data, loading, error }] = useBuildingCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBuildingCreateMutation(baseOptions?: Apollo.MutationHookOptions<BuildingCreateMutation, BuildingCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildingCreateMutation, BuildingCreateMutationVariables>(BuildingCreateDocument, options);
      }
export type BuildingCreateMutationHookResult = ReturnType<typeof useBuildingCreateMutation>;
export type BuildingCreateMutationResult = Apollo.MutationResult<BuildingCreateMutation>;
export type BuildingCreateMutationOptions = Apollo.BaseMutationOptions<BuildingCreateMutation, BuildingCreateMutationVariables>;
export const BuildingUpdateDocument = gql`
    mutation BuildingUpdate($data: BuildingUpdateInput!) {
  buildingUpdate(data: $data) {
    id
    createdAt
    updatedAt
    name
    defaultName
    projectRef
    slug
    picture
    thumb
    epcRating
    epcUrl
    floorArea
    hasFileServer
    hasDataServer
    dashboardPeriod
    dashboardStyle
    lastSeen
    buildingTransmitting
    breeamScore
    isOccupied
    isSubscribedDatalake
    isSubscribedOptitwin
    mqttInfo {
      mqttUsername
      mqttPassword
    }
    uploadConfig {
      ftpConfig {
        id
        buildingId
        connectionType
        parser
      }
      mqttConfig {
        id
        buildingId
        connectionType
        host
        password
        port
        protocol
        topic
        useDefaultServer
        username
      }
    }
  }
}
    `;
export type BuildingUpdateMutationFn = Apollo.MutationFunction<BuildingUpdateMutation, BuildingUpdateMutationVariables>;

/**
 * __useBuildingUpdateMutation__
 *
 * To run a mutation, you first call `useBuildingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingUpdateMutation, { data, loading, error }] = useBuildingUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBuildingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BuildingUpdateMutation, BuildingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildingUpdateMutation, BuildingUpdateMutationVariables>(BuildingUpdateDocument, options);
      }
export type BuildingUpdateMutationHookResult = ReturnType<typeof useBuildingUpdateMutation>;
export type BuildingUpdateMutationResult = Apollo.MutationResult<BuildingUpdateMutation>;
export type BuildingUpdateMutationOptions = Apollo.BaseMutationOptions<BuildingUpdateMutation, BuildingUpdateMutationVariables>;
export const BuildingDeleteDocument = gql`
    mutation BuildingDelete($data: BuildingDeleteInput!) {
  buildingDelete(data: $data) {
    message
  }
}
    `;
export type BuildingDeleteMutationFn = Apollo.MutationFunction<BuildingDeleteMutation, BuildingDeleteMutationVariables>;

/**
 * __useBuildingDeleteMutation__
 *
 * To run a mutation, you first call `useBuildingDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildingDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildingDeleteMutation, { data, loading, error }] = useBuildingDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBuildingDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BuildingDeleteMutation, BuildingDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildingDeleteMutation, BuildingDeleteMutationVariables>(BuildingDeleteDocument, options);
      }
export type BuildingDeleteMutationHookResult = ReturnType<typeof useBuildingDeleteMutation>;
export type BuildingDeleteMutationResult = Apollo.MutationResult<BuildingDeleteMutation>;
export type BuildingDeleteMutationOptions = Apollo.BaseMutationOptions<BuildingDeleteMutation, BuildingDeleteMutationVariables>;
export const DashboardUpdateDocument = gql`
    mutation DashboardUpdate($data: DashboardUpdateInput!) {
  dashboardUpdate(data: $data) {
    id
    period
    tryMessage
    infoMessage
  }
}
    `;
export type DashboardUpdateMutationFn = Apollo.MutationFunction<DashboardUpdateMutation, DashboardUpdateMutationVariables>;

/**
 * __useDashboardUpdateMutation__
 *
 * To run a mutation, you first call `useDashboardUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDashboardUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dashboardUpdateMutation, { data, loading, error }] = useDashboardUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDashboardUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DashboardUpdateMutation, DashboardUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DashboardUpdateMutation, DashboardUpdateMutationVariables>(DashboardUpdateDocument, options);
      }
export type DashboardUpdateMutationHookResult = ReturnType<typeof useDashboardUpdateMutation>;
export type DashboardUpdateMutationResult = Apollo.MutationResult<DashboardUpdateMutation>;
export type DashboardUpdateMutationOptions = Apollo.BaseMutationOptions<DashboardUpdateMutation, DashboardUpdateMutationVariables>;
export const SignInDocument = gql`
    mutation signIn($email: String!, $password: String!) {
  signIn(email: $email, password: $password) {
    token
    message
    user {
      id
      firstName
      lastName
      slug
      picture
      isStaff
      isAdmin
      companyId
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignOutDocument = gql`
    mutation signOut {
  signOut {
    message
  }
}
    `;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
      }
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<SignOutMutation, SignOutMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation createCompany($data: CompanyCreateInput!) {
  companyCreate(data: $data) {
    id
    createdAt
    updatedAt
    name
    slug
    portfolioImage
    logo
    userIds
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($data: UserCreateInput!) {
  userCreate(data: $data) {
    id
    createdAt
    updatedAt
    companyId
    email
    firstName
    lastName
    slug
    picture
    role
    customPermissions
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const AddCompanyRelationshipDocument = gql`
    mutation AddCompanyRelationship($data: AddCompanyRelationshipInput!) {
  addCompanyRelationship(data: $data) {
    buildingId
    companyId
    companyName
    buildingName
    companyReference
    companyReferenceName
    relationshipType
  }
}
    `;
export type AddCompanyRelationshipMutationFn = Apollo.MutationFunction<AddCompanyRelationshipMutation, AddCompanyRelationshipMutationVariables>;

/**
 * __useAddCompanyRelationshipMutation__
 *
 * To run a mutation, you first call `useAddCompanyRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyRelationshipMutation, { data, loading, error }] = useAddCompanyRelationshipMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddCompanyRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyRelationshipMutation, AddCompanyRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyRelationshipMutation, AddCompanyRelationshipMutationVariables>(AddCompanyRelationshipDocument, options);
      }
export type AddCompanyRelationshipMutationHookResult = ReturnType<typeof useAddCompanyRelationshipMutation>;
export type AddCompanyRelationshipMutationResult = Apollo.MutationResult<AddCompanyRelationshipMutation>;
export type AddCompanyRelationshipMutationOptions = Apollo.BaseMutationOptions<AddCompanyRelationshipMutation, AddCompanyRelationshipMutationVariables>;
export const RemoveCompanyRelationshipDocument = gql`
    mutation RemoveCompanyRelationship($data: RemoveCompanyRelationshipInput!) {
  removeCompanyRelationship(data: $data) {
    message
  }
}
    `;
export type RemoveCompanyRelationshipMutationFn = Apollo.MutationFunction<RemoveCompanyRelationshipMutation, RemoveCompanyRelationshipMutationVariables>;

/**
 * __useRemoveCompanyRelationshipMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyRelationshipMutation, { data, loading, error }] = useRemoveCompanyRelationshipMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCompanyRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyRelationshipMutation, RemoveCompanyRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyRelationshipMutation, RemoveCompanyRelationshipMutationVariables>(RemoveCompanyRelationshipDocument, options);
      }
export type RemoveCompanyRelationshipMutationHookResult = ReturnType<typeof useRemoveCompanyRelationshipMutation>;
export type RemoveCompanyRelationshipMutationResult = Apollo.MutationResult<RemoveCompanyRelationshipMutation>;
export type RemoveCompanyRelationshipMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyRelationshipMutation, RemoveCompanyRelationshipMutationVariables>;
export const UpdateCompanyRelationshipDocument = gql`
    mutation UpdateCompanyRelationship($data: UpdateCompanyRelationshipInput!) {
  updateCompanyRelationship(data: $data) {
    companyId
    buildingId
    companyName
    buildingName
    companyReference
    companyReferenceName
    relationshipType
  }
}
    `;
export type UpdateCompanyRelationshipMutationFn = Apollo.MutationFunction<UpdateCompanyRelationshipMutation, UpdateCompanyRelationshipMutationVariables>;

/**
 * __useUpdateCompanyRelationshipMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyRelationshipMutation, { data, loading, error }] = useUpdateCompanyRelationshipMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompanyRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyRelationshipMutation, UpdateCompanyRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyRelationshipMutation, UpdateCompanyRelationshipMutationVariables>(UpdateCompanyRelationshipDocument, options);
      }
export type UpdateCompanyRelationshipMutationHookResult = ReturnType<typeof useUpdateCompanyRelationshipMutation>;
export type UpdateCompanyRelationshipMutationResult = Apollo.MutationResult<UpdateCompanyRelationshipMutation>;
export type UpdateCompanyRelationshipMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyRelationshipMutation, UpdateCompanyRelationshipMutationVariables>;
export const ResetFlagDocument = gql`
    mutation ResetFlag($where: ResetFlagInput!) {
  resetFlag(where: $where) {
    message
  }
}
    `;
export type ResetFlagMutationFn = Apollo.MutationFunction<ResetFlagMutation, ResetFlagMutationVariables>;

/**
 * __useResetFlagMutation__
 *
 * To run a mutation, you first call `useResetFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetFlagMutation, { data, loading, error }] = useResetFlagMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useResetFlagMutation(baseOptions?: Apollo.MutationHookOptions<ResetFlagMutation, ResetFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetFlagMutation, ResetFlagMutationVariables>(ResetFlagDocument, options);
      }
export type ResetFlagMutationHookResult = ReturnType<typeof useResetFlagMutation>;
export type ResetFlagMutationResult = Apollo.MutationResult<ResetFlagMutation>;
export type ResetFlagMutationOptions = Apollo.BaseMutationOptions<ResetFlagMutation, ResetFlagMutationVariables>;
export const InspectorChannelUpdateOneDocument = gql`
    mutation InspectorChannelUpdateOne($where: InspectorChannelUpdateOneInput!) {
  inspectorChannelUpdateOne(where: $where) {
    channelId
    lastSeen
    isImportant
    notTransmitting
    notCumulative
    includesZeroes
    isDisabled
  }
}
    `;
export type InspectorChannelUpdateOneMutationFn = Apollo.MutationFunction<InspectorChannelUpdateOneMutation, InspectorChannelUpdateOneMutationVariables>;

/**
 * __useInspectorChannelUpdateOneMutation__
 *
 * To run a mutation, you first call `useInspectorChannelUpdateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInspectorChannelUpdateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inspectorChannelUpdateOneMutation, { data, loading, error }] = useInspectorChannelUpdateOneMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInspectorChannelUpdateOneMutation(baseOptions?: Apollo.MutationHookOptions<InspectorChannelUpdateOneMutation, InspectorChannelUpdateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InspectorChannelUpdateOneMutation, InspectorChannelUpdateOneMutationVariables>(InspectorChannelUpdateOneDocument, options);
      }
export type InspectorChannelUpdateOneMutationHookResult = ReturnType<typeof useInspectorChannelUpdateOneMutation>;
export type InspectorChannelUpdateOneMutationResult = Apollo.MutationResult<InspectorChannelUpdateOneMutation>;
export type InspectorChannelUpdateOneMutationOptions = Apollo.BaseMutationOptions<InspectorChannelUpdateOneMutation, InspectorChannelUpdateOneMutationVariables>;
export const TargetAlertUpdateDocument = gql`
    mutation TargetAlertUpdate($data: TargetAlertUpdate!) {
  targetAlertUpdate(data: $data) {
    name
    benchmark
    channelId
    triggerCondition
    isDashboardDefault
  }
}
    `;
export type TargetAlertUpdateMutationFn = Apollo.MutationFunction<TargetAlertUpdateMutation, TargetAlertUpdateMutationVariables>;

/**
 * __useTargetAlertUpdateMutation__
 *
 * To run a mutation, you first call `useTargetAlertUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTargetAlertUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [targetAlertUpdateMutation, { data, loading, error }] = useTargetAlertUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTargetAlertUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TargetAlertUpdateMutation, TargetAlertUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TargetAlertUpdateMutation, TargetAlertUpdateMutationVariables>(TargetAlertUpdateDocument, options);
      }
export type TargetAlertUpdateMutationHookResult = ReturnType<typeof useTargetAlertUpdateMutation>;
export type TargetAlertUpdateMutationResult = Apollo.MutationResult<TargetAlertUpdateMutation>;
export type TargetAlertUpdateMutationOptions = Apollo.BaseMutationOptions<TargetAlertUpdateMutation, TargetAlertUpdateMutationVariables>;
export const TargetAlertUpdateManyDocument = gql`
    mutation TargetAlertUpdateMany($data: targetAlertUpdateMany!) {
  targetAlertUpdateMany(data: $data) {
    name
    benchmark
    channelId
    triggerCondition
    isDashboardDefault
    severity
    daily {
      targetId
      targetValue
      alertId
    }
    weekly {
      targetId
      targetValue
      alertId
    }
    monthly {
      targetId
      targetValue
      alertId
    }
    yearly {
      targetId
      targetValue
      alertId
    }
  }
}
    `;
export type TargetAlertUpdateManyMutationFn = Apollo.MutationFunction<TargetAlertUpdateManyMutation, TargetAlertUpdateManyMutationVariables>;

/**
 * __useTargetAlertUpdateManyMutation__
 *
 * To run a mutation, you first call `useTargetAlertUpdateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTargetAlertUpdateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [targetAlertUpdateManyMutation, { data, loading, error }] = useTargetAlertUpdateManyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTargetAlertUpdateManyMutation(baseOptions?: Apollo.MutationHookOptions<TargetAlertUpdateManyMutation, TargetAlertUpdateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TargetAlertUpdateManyMutation, TargetAlertUpdateManyMutationVariables>(TargetAlertUpdateManyDocument, options);
      }
export type TargetAlertUpdateManyMutationHookResult = ReturnType<typeof useTargetAlertUpdateManyMutation>;
export type TargetAlertUpdateManyMutationResult = Apollo.MutationResult<TargetAlertUpdateManyMutation>;
export type TargetAlertUpdateManyMutationOptions = Apollo.BaseMutationOptions<TargetAlertUpdateManyMutation, TargetAlertUpdateManyMutationVariables>;
export const TargetAlertDeleteDocument = gql`
    mutation TargetAlertDelete($where: TargetAlertDeleteInput!) {
  targetAlertDelete(where: $where) {
    message
  }
}
    `;
export type TargetAlertDeleteMutationFn = Apollo.MutationFunction<TargetAlertDeleteMutation, TargetAlertDeleteMutationVariables>;

/**
 * __useTargetAlertDeleteMutation__
 *
 * To run a mutation, you first call `useTargetAlertDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTargetAlertDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [targetAlertDeleteMutation, { data, loading, error }] = useTargetAlertDeleteMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTargetAlertDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TargetAlertDeleteMutation, TargetAlertDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TargetAlertDeleteMutation, TargetAlertDeleteMutationVariables>(TargetAlertDeleteDocument, options);
      }
export type TargetAlertDeleteMutationHookResult = ReturnType<typeof useTargetAlertDeleteMutation>;
export type TargetAlertDeleteMutationResult = Apollo.MutationResult<TargetAlertDeleteMutation>;
export type TargetAlertDeleteMutationOptions = Apollo.BaseMutationOptions<TargetAlertDeleteMutation, TargetAlertDeleteMutationVariables>;
export const CheckChannelDataDocument = gql`
    mutation CheckChannelData($data: CheckChannelDataInput!) {
  checkChannelData(data: $data) {
    message
  }
}
    `;
export type CheckChannelDataMutationFn = Apollo.MutationFunction<CheckChannelDataMutation, CheckChannelDataMutationVariables>;

/**
 * __useCheckChannelDataMutation__
 *
 * To run a mutation, you first call `useCheckChannelDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckChannelDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkChannelDataMutation, { data, loading, error }] = useCheckChannelDataMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckChannelDataMutation(baseOptions?: Apollo.MutationHookOptions<CheckChannelDataMutation, CheckChannelDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckChannelDataMutation, CheckChannelDataMutationVariables>(CheckChannelDataDocument, options);
      }
export type CheckChannelDataMutationHookResult = ReturnType<typeof useCheckChannelDataMutation>;
export type CheckChannelDataMutationResult = Apollo.MutationResult<CheckChannelDataMutation>;
export type CheckChannelDataMutationOptions = Apollo.BaseMutationOptions<CheckChannelDataMutation, CheckChannelDataMutationVariables>;
export const CheckBuildingDataDocument = gql`
    mutation CheckBuildingData($data: CheckBuildingDataInput!) {
  checkBuildingData(data: $data) {
    message
  }
}
    `;
export type CheckBuildingDataMutationFn = Apollo.MutationFunction<CheckBuildingDataMutation, CheckBuildingDataMutationVariables>;

/**
 * __useCheckBuildingDataMutation__
 *
 * To run a mutation, you first call `useCheckBuildingDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckBuildingDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkBuildingDataMutation, { data, loading, error }] = useCheckBuildingDataMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckBuildingDataMutation(baseOptions?: Apollo.MutationHookOptions<CheckBuildingDataMutation, CheckBuildingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckBuildingDataMutation, CheckBuildingDataMutationVariables>(CheckBuildingDataDocument, options);
      }
export type CheckBuildingDataMutationHookResult = ReturnType<typeof useCheckBuildingDataMutation>;
export type CheckBuildingDataMutationResult = Apollo.MutationResult<CheckBuildingDataMutation>;
export type CheckBuildingDataMutationOptions = Apollo.BaseMutationOptions<CheckBuildingDataMutation, CheckBuildingDataMutationVariables>;
export const CheckAllDataDocument = gql`
    mutation CheckAllData($data: CheckAllDataInput!) {
  checkAllData(data: $data) {
    message
  }
}
    `;
export type CheckAllDataMutationFn = Apollo.MutationFunction<CheckAllDataMutation, CheckAllDataMutationVariables>;

/**
 * __useCheckAllDataMutation__
 *
 * To run a mutation, you first call `useCheckAllDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckAllDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkAllDataMutation, { data, loading, error }] = useCheckAllDataMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckAllDataMutation(baseOptions?: Apollo.MutationHookOptions<CheckAllDataMutation, CheckAllDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckAllDataMutation, CheckAllDataMutationVariables>(CheckAllDataDocument, options);
      }
export type CheckAllDataMutationHookResult = ReturnType<typeof useCheckAllDataMutation>;
export type CheckAllDataMutationResult = Apollo.MutationResult<CheckAllDataMutation>;
export type CheckAllDataMutationOptions = Apollo.BaseMutationOptions<CheckAllDataMutation, CheckAllDataMutationVariables>;
export const TargetAlertCreateDocument = gql`
    mutation TargetAlertCreate($data: TargetAlertCreateInput!) {
  targetAlertCreate(data: $data) {
    name
    benchmark
    channelId
    triggerCondition
    isDashboardDefault
    severity
    daily {
      targetId
      targetValue
      alertId
    }
    weekly {
      targetId
      targetValue
      alertId
    }
    monthly {
      targetId
      targetValue
      alertId
    }
    yearly {
      targetId
      targetValue
      alertId
    }
  }
}
    `;
export type TargetAlertCreateMutationFn = Apollo.MutationFunction<TargetAlertCreateMutation, TargetAlertCreateMutationVariables>;

/**
 * __useTargetAlertCreateMutation__
 *
 * To run a mutation, you first call `useTargetAlertCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTargetAlertCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [targetAlertCreateMutation, { data, loading, error }] = useTargetAlertCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTargetAlertCreateMutation(baseOptions?: Apollo.MutationHookOptions<TargetAlertCreateMutation, TargetAlertCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TargetAlertCreateMutation, TargetAlertCreateMutationVariables>(TargetAlertCreateDocument, options);
      }
export type TargetAlertCreateMutationHookResult = ReturnType<typeof useTargetAlertCreateMutation>;
export type TargetAlertCreateMutationResult = Apollo.MutationResult<TargetAlertCreateMutation>;
export type TargetAlertCreateMutationOptions = Apollo.BaseMutationOptions<TargetAlertCreateMutation, TargetAlertCreateMutationVariables>;
export const ChannelUpdateManyDocument = gql`
    mutation ChannelUpdateMany($data: ChannelUpdateManyInput!) {
  channelUpdateMany(data: $data) {
    id
    name
    measurementType
  }
}
    `;
export type ChannelUpdateManyMutationFn = Apollo.MutationFunction<ChannelUpdateManyMutation, ChannelUpdateManyMutationVariables>;

/**
 * __useChannelUpdateManyMutation__
 *
 * To run a mutation, you first call `useChannelUpdateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChannelUpdateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [channelUpdateManyMutation, { data, loading, error }] = useChannelUpdateManyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChannelUpdateManyMutation(baseOptions?: Apollo.MutationHookOptions<ChannelUpdateManyMutation, ChannelUpdateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChannelUpdateManyMutation, ChannelUpdateManyMutationVariables>(ChannelUpdateManyDocument, options);
      }
export type ChannelUpdateManyMutationHookResult = ReturnType<typeof useChannelUpdateManyMutation>;
export type ChannelUpdateManyMutationResult = Apollo.MutationResult<ChannelUpdateManyMutation>;
export type ChannelUpdateManyMutationOptions = Apollo.BaseMutationOptions<ChannelUpdateManyMutation, ChannelUpdateManyMutationVariables>;
export const GasCaloriesCreateByUrlDocument = gql`
    mutation GasCaloriesCreateByUrl($where: GasCaloriesCreateByUrlInput!) {
  gasCaloriesCreateByUrl(where: $where) {
    message
  }
}
    `;
export type GasCaloriesCreateByUrlMutationFn = Apollo.MutationFunction<GasCaloriesCreateByUrlMutation, GasCaloriesCreateByUrlMutationVariables>;

/**
 * __useGasCaloriesCreateByUrlMutation__
 *
 * To run a mutation, you first call `useGasCaloriesCreateByUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGasCaloriesCreateByUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gasCaloriesCreateByUrlMutation, { data, loading, error }] = useGasCaloriesCreateByUrlMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGasCaloriesCreateByUrlMutation(baseOptions?: Apollo.MutationHookOptions<GasCaloriesCreateByUrlMutation, GasCaloriesCreateByUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GasCaloriesCreateByUrlMutation, GasCaloriesCreateByUrlMutationVariables>(GasCaloriesCreateByUrlDocument, options);
      }
export type GasCaloriesCreateByUrlMutationHookResult = ReturnType<typeof useGasCaloriesCreateByUrlMutation>;
export type GasCaloriesCreateByUrlMutationResult = Apollo.MutationResult<GasCaloriesCreateByUrlMutation>;
export type GasCaloriesCreateByUrlMutationOptions = Apollo.BaseMutationOptions<GasCaloriesCreateByUrlMutation, GasCaloriesCreateByUrlMutationVariables>;
export const GasCaloriesCreateDocument = gql`
    mutation GasCaloriesCreate($data: GasCaloriesCreateInput!) {
  gasCaloriesCreate(data: $data) {
    id
    country
    date
    value
  }
}
    `;
export type GasCaloriesCreateMutationFn = Apollo.MutationFunction<GasCaloriesCreateMutation, GasCaloriesCreateMutationVariables>;

/**
 * __useGasCaloriesCreateMutation__
 *
 * To run a mutation, you first call `useGasCaloriesCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGasCaloriesCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gasCaloriesCreateMutation, { data, loading, error }] = useGasCaloriesCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGasCaloriesCreateMutation(baseOptions?: Apollo.MutationHookOptions<GasCaloriesCreateMutation, GasCaloriesCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GasCaloriesCreateMutation, GasCaloriesCreateMutationVariables>(GasCaloriesCreateDocument, options);
      }
export type GasCaloriesCreateMutationHookResult = ReturnType<typeof useGasCaloriesCreateMutation>;
export type GasCaloriesCreateMutationResult = Apollo.MutationResult<GasCaloriesCreateMutation>;
export type GasCaloriesCreateMutationOptions = Apollo.BaseMutationOptions<GasCaloriesCreateMutation, GasCaloriesCreateMutationVariables>;
export const GasCarbonCreateDocument = gql`
    mutation GasCarbonCreate($data: GasCarbonCreateInput!) {
  gasCarbonCreate(data: $data) {
    id
    country
    date
    value
  }
}
    `;
export type GasCarbonCreateMutationFn = Apollo.MutationFunction<GasCarbonCreateMutation, GasCarbonCreateMutationVariables>;

/**
 * __useGasCarbonCreateMutation__
 *
 * To run a mutation, you first call `useGasCarbonCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGasCarbonCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gasCarbonCreateMutation, { data, loading, error }] = useGasCarbonCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGasCarbonCreateMutation(baseOptions?: Apollo.MutationHookOptions<GasCarbonCreateMutation, GasCarbonCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GasCarbonCreateMutation, GasCarbonCreateMutationVariables>(GasCarbonCreateDocument, options);
      }
export type GasCarbonCreateMutationHookResult = ReturnType<typeof useGasCarbonCreateMutation>;
export type GasCarbonCreateMutationResult = Apollo.MutationResult<GasCarbonCreateMutation>;
export type GasCarbonCreateMutationOptions = Apollo.BaseMutationOptions<GasCarbonCreateMutation, GasCarbonCreateMutationVariables>;
export const ElectricityCarbonCreateDocument = gql`
    mutation ElectricityCarbonCreate($data: ElectricityCarbonCreateInput!) {
  electricityCarbonCreate(data: $data) {
    id
    country
    date
    value
  }
}
    `;
export type ElectricityCarbonCreateMutationFn = Apollo.MutationFunction<ElectricityCarbonCreateMutation, ElectricityCarbonCreateMutationVariables>;

/**
 * __useElectricityCarbonCreateMutation__
 *
 * To run a mutation, you first call `useElectricityCarbonCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useElectricityCarbonCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [electricityCarbonCreateMutation, { data, loading, error }] = useElectricityCarbonCreateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useElectricityCarbonCreateMutation(baseOptions?: Apollo.MutationHookOptions<ElectricityCarbonCreateMutation, ElectricityCarbonCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ElectricityCarbonCreateMutation, ElectricityCarbonCreateMutationVariables>(ElectricityCarbonCreateDocument, options);
      }
export type ElectricityCarbonCreateMutationHookResult = ReturnType<typeof useElectricityCarbonCreateMutation>;
export type ElectricityCarbonCreateMutationResult = Apollo.MutationResult<ElectricityCarbonCreateMutation>;
export type ElectricityCarbonCreateMutationOptions = Apollo.BaseMutationOptions<ElectricityCarbonCreateMutation, ElectricityCarbonCreateMutationVariables>;
export const GasCaloriesDeleteDocument = gql`
    mutation GasCaloriesDelete($data: GasCaloriesDeleteInput!) {
  gasCaloriesDelete(data: $data) {
    message
  }
}
    `;
export type GasCaloriesDeleteMutationFn = Apollo.MutationFunction<GasCaloriesDeleteMutation, GasCaloriesDeleteMutationVariables>;

/**
 * __useGasCaloriesDeleteMutation__
 *
 * To run a mutation, you first call `useGasCaloriesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGasCaloriesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gasCaloriesDeleteMutation, { data, loading, error }] = useGasCaloriesDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGasCaloriesDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GasCaloriesDeleteMutation, GasCaloriesDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GasCaloriesDeleteMutation, GasCaloriesDeleteMutationVariables>(GasCaloriesDeleteDocument, options);
      }
export type GasCaloriesDeleteMutationHookResult = ReturnType<typeof useGasCaloriesDeleteMutation>;
export type GasCaloriesDeleteMutationResult = Apollo.MutationResult<GasCaloriesDeleteMutation>;
export type GasCaloriesDeleteMutationOptions = Apollo.BaseMutationOptions<GasCaloriesDeleteMutation, GasCaloriesDeleteMutationVariables>;
export const GasCarbonDeleteDocument = gql`
    mutation GasCarbonDelete($data: GasCarbonDeleteInput!) {
  gasCarbonDelete(data: $data) {
    message
  }
}
    `;
export type GasCarbonDeleteMutationFn = Apollo.MutationFunction<GasCarbonDeleteMutation, GasCarbonDeleteMutationVariables>;

/**
 * __useGasCarbonDeleteMutation__
 *
 * To run a mutation, you first call `useGasCarbonDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGasCarbonDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gasCarbonDeleteMutation, { data, loading, error }] = useGasCarbonDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGasCarbonDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GasCarbonDeleteMutation, GasCarbonDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GasCarbonDeleteMutation, GasCarbonDeleteMutationVariables>(GasCarbonDeleteDocument, options);
      }
export type GasCarbonDeleteMutationHookResult = ReturnType<typeof useGasCarbonDeleteMutation>;
export type GasCarbonDeleteMutationResult = Apollo.MutationResult<GasCarbonDeleteMutation>;
export type GasCarbonDeleteMutationOptions = Apollo.BaseMutationOptions<GasCarbonDeleteMutation, GasCarbonDeleteMutationVariables>;
export const ElectricityCarbonDeleteDocument = gql`
    mutation ElectricityCarbonDelete($data: ElectricityCarbonDeleteInput!) {
  electricityCarbonDelete(data: $data) {
    message
  }
}
    `;
export type ElectricityCarbonDeleteMutationFn = Apollo.MutationFunction<ElectricityCarbonDeleteMutation, ElectricityCarbonDeleteMutationVariables>;

/**
 * __useElectricityCarbonDeleteMutation__
 *
 * To run a mutation, you first call `useElectricityCarbonDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useElectricityCarbonDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [electricityCarbonDeleteMutation, { data, loading, error }] = useElectricityCarbonDeleteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useElectricityCarbonDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ElectricityCarbonDeleteMutation, ElectricityCarbonDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ElectricityCarbonDeleteMutation, ElectricityCarbonDeleteMutationVariables>(ElectricityCarbonDeleteDocument, options);
      }
export type ElectricityCarbonDeleteMutationHookResult = ReturnType<typeof useElectricityCarbonDeleteMutation>;
export type ElectricityCarbonDeleteMutationResult = Apollo.MutationResult<ElectricityCarbonDeleteMutation>;
export type ElectricityCarbonDeleteMutationOptions = Apollo.BaseMutationOptions<ElectricityCarbonDeleteMutation, ElectricityCarbonDeleteMutationVariables>;
export const AccountUpdateDocument = gql`
    mutation AccountUpdate($data: UserChangeInput!) {
  userUpdate(data: $data) {
    id
    email
  }
}
    `;
export type AccountUpdateMutationFn = Apollo.MutationFunction<AccountUpdateMutation, AccountUpdateMutationVariables>;

/**
 * __useAccountUpdateMutation__
 *
 * To run a mutation, you first call `useAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateMutation, { data, loading, error }] = useAccountUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAccountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateMutation, AccountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateMutation, AccountUpdateMutationVariables>(AccountUpdateDocument, options);
      }
export type AccountUpdateMutationHookResult = ReturnType<typeof useAccountUpdateMutation>;
export type AccountUpdateMutationResult = Apollo.MutationResult<AccountUpdateMutation>;
export type AccountUpdateMutationOptions = Apollo.BaseMutationOptions<AccountUpdateMutation, AccountUpdateMutationVariables>;
export const ReportingUpdateDocument = gql`
    mutation ReportingUpdate($data: ReportingUpdateInput!) {
  reportingUpdate(data: $data) {
    result
  }
}
    `;
export type ReportingUpdateMutationFn = Apollo.MutationFunction<ReportingUpdateMutation, ReportingUpdateMutationVariables>;

/**
 * __useReportingUpdateMutation__
 *
 * To run a mutation, you first call `useReportingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportingUpdateMutation, { data, loading, error }] = useReportingUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReportingUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ReportingUpdateMutation, ReportingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportingUpdateMutation, ReportingUpdateMutationVariables>(ReportingUpdateDocument, options);
      }
export type ReportingUpdateMutationHookResult = ReturnType<typeof useReportingUpdateMutation>;
export type ReportingUpdateMutationResult = Apollo.MutationResult<ReportingUpdateMutation>;
export type ReportingUpdateMutationOptions = Apollo.BaseMutationOptions<ReportingUpdateMutation, ReportingUpdateMutationVariables>;
export const BuildingGetIdDocument = gql`
    query BuildingGetId($where: BuildingWhereUniqueSearchOneInput!) {
  buildingGetOne(where: $where) {
    id
    name
  }
}
    `;

/**
 * __useBuildingGetIdQuery__
 *
 * To run a query within a React component, call `useBuildingGetIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingGetIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingGetIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBuildingGetIdQuery(baseOptions: Apollo.QueryHookOptions<BuildingGetIdQuery, BuildingGetIdQueryVariables> & ({ variables: BuildingGetIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingGetIdQuery, BuildingGetIdQueryVariables>(BuildingGetIdDocument, options);
      }
export function useBuildingGetIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingGetIdQuery, BuildingGetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingGetIdQuery, BuildingGetIdQueryVariables>(BuildingGetIdDocument, options);
        }
export function useBuildingGetIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingGetIdQuery, BuildingGetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildingGetIdQuery, BuildingGetIdQueryVariables>(BuildingGetIdDocument, options);
        }
export type BuildingGetIdQueryHookResult = ReturnType<typeof useBuildingGetIdQuery>;
export type BuildingGetIdLazyQueryHookResult = ReturnType<typeof useBuildingGetIdLazyQuery>;
export type BuildingGetIdSuspenseQueryHookResult = ReturnType<typeof useBuildingGetIdSuspenseQuery>;
export type BuildingGetIdQueryResult = Apollo.QueryResult<BuildingGetIdQuery, BuildingGetIdQueryVariables>;
export const ChannelSearchManyDocument = gql`
    query ChannelSearchMany($where: ChannelSearchManyInput!) {
  channelSearchMany(where: $where) {
    id
    createdAt
    updatedAt
    name
    reference
    period
    incomingUnit
    measurementType
    buildingId
    parentId
    channelType
    isDisabled
    channelIssues {
      lastSeen
      isImportant
      notTransmitting
      notCumulative
      includesZeroes
      isDisabled
    }
  }
}
    `;

/**
 * __useChannelSearchManyQuery__
 *
 * To run a query within a React component, call `useChannelSearchManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelSearchManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelSearchManyQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useChannelSearchManyQuery(baseOptions: Apollo.QueryHookOptions<ChannelSearchManyQuery, ChannelSearchManyQueryVariables> & ({ variables: ChannelSearchManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelSearchManyQuery, ChannelSearchManyQueryVariables>(ChannelSearchManyDocument, options);
      }
export function useChannelSearchManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelSearchManyQuery, ChannelSearchManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelSearchManyQuery, ChannelSearchManyQueryVariables>(ChannelSearchManyDocument, options);
        }
export function useChannelSearchManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelSearchManyQuery, ChannelSearchManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelSearchManyQuery, ChannelSearchManyQueryVariables>(ChannelSearchManyDocument, options);
        }
export type ChannelSearchManyQueryHookResult = ReturnType<typeof useChannelSearchManyQuery>;
export type ChannelSearchManyLazyQueryHookResult = ReturnType<typeof useChannelSearchManyLazyQuery>;
export type ChannelSearchManySuspenseQueryHookResult = ReturnType<typeof useChannelSearchManySuspenseQuery>;
export type ChannelSearchManyQueryResult = Apollo.QueryResult<ChannelSearchManyQuery, ChannelSearchManyQueryVariables>;
export const CompositeChannelRelationshipsDocument = gql`
    query CompositeChannelRelationships($where: CompositeChannelGetManyInput!) {
  compositeChannelRelationships(where: $where) {
    name
    id
    composite
    isDashboardDefault
    children {
      name
      id
      composite
      isDashboardDefault
      children {
        name
        id
        composite
        isDashboardDefault
        children {
          name
          id
          composite
          isDashboardDefault
          children {
            name
            id
            composite
            isDashboardDefault
            children {
              name
              id
              composite
              isDashboardDefault
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCompositeChannelRelationshipsQuery__
 *
 * To run a query within a React component, call `useCompositeChannelRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompositeChannelRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompositeChannelRelationshipsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompositeChannelRelationshipsQuery(baseOptions: Apollo.QueryHookOptions<CompositeChannelRelationshipsQuery, CompositeChannelRelationshipsQueryVariables> & ({ variables: CompositeChannelRelationshipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompositeChannelRelationshipsQuery, CompositeChannelRelationshipsQueryVariables>(CompositeChannelRelationshipsDocument, options);
      }
export function useCompositeChannelRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompositeChannelRelationshipsQuery, CompositeChannelRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompositeChannelRelationshipsQuery, CompositeChannelRelationshipsQueryVariables>(CompositeChannelRelationshipsDocument, options);
        }
export function useCompositeChannelRelationshipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompositeChannelRelationshipsQuery, CompositeChannelRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompositeChannelRelationshipsQuery, CompositeChannelRelationshipsQueryVariables>(CompositeChannelRelationshipsDocument, options);
        }
export type CompositeChannelRelationshipsQueryHookResult = ReturnType<typeof useCompositeChannelRelationshipsQuery>;
export type CompositeChannelRelationshipsLazyQueryHookResult = ReturnType<typeof useCompositeChannelRelationshipsLazyQuery>;
export type CompositeChannelRelationshipsSuspenseQueryHookResult = ReturnType<typeof useCompositeChannelRelationshipsSuspenseQuery>;
export type CompositeChannelRelationshipsQueryResult = Apollo.QueryResult<CompositeChannelRelationshipsQuery, CompositeChannelRelationshipsQueryVariables>;
export const ChannelMeterRelationshipsDocument = gql`
    query ChannelMeterRelationships($where: SearchChannelByBuildingIdInput!) {
  channelMeterRelationships(where: $where) {
    id
    createdAt
    updatedAt
    name
    reference
    period
    incomingUnit
    measurementType
    buildingId
    parentId
    channelType
    channelIssues {
      lastSeen
      isImportant
      notTransmitting
      notCumulative
      includesZeroes
      isDisabled
    }
    children {
      id
      createdAt
      updatedAt
      name
      reference
      period
      measurementType
      buildingId
      parentId
      channelType
      channelIssues {
        lastSeen
        isImportant
        notCumulative
        includesZeroes
        isDisabled
      }
      children {
        id
        createdAt
        updatedAt
        name
        reference
        period
        measurementType
        buildingId
        parentId
        channelType
        channelIssues {
          lastSeen
          isImportant
          notTransmitting
          notCumulative
          includesZeroes
          isDisabled
        }
        children {
          id
          createdAt
          updatedAt
          name
          reference
          period
          measurementType
          buildingId
          parentId
          channelType
          channelIssues {
            lastSeen
            isImportant
            notTransmitting
            notCumulative
            includesZeroes
            isDisabled
          }
          children {
            id
            createdAt
            updatedAt
            name
            reference
            period
            measurementType
            buildingId
            parentId
            channelType
            channelIssues {
              lastSeen
              isImportant
              notTransmitting
              notCumulative
              includesZeroes
              isDisabled
            }
            children {
              id
              createdAt
              updatedAt
              name
              reference
              period
              measurementType
              buildingId
              parentId
              channelType
              channelIssues {
                lastSeen
                isImportant
                notTransmitting
                notCumulative
                includesZeroes
                isDisabled
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useChannelMeterRelationshipsQuery__
 *
 * To run a query within a React component, call `useChannelMeterRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelMeterRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelMeterRelationshipsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useChannelMeterRelationshipsQuery(baseOptions: Apollo.QueryHookOptions<ChannelMeterRelationshipsQuery, ChannelMeterRelationshipsQueryVariables> & ({ variables: ChannelMeterRelationshipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelMeterRelationshipsQuery, ChannelMeterRelationshipsQueryVariables>(ChannelMeterRelationshipsDocument, options);
      }
export function useChannelMeterRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelMeterRelationshipsQuery, ChannelMeterRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelMeterRelationshipsQuery, ChannelMeterRelationshipsQueryVariables>(ChannelMeterRelationshipsDocument, options);
        }
export function useChannelMeterRelationshipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChannelMeterRelationshipsQuery, ChannelMeterRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChannelMeterRelationshipsQuery, ChannelMeterRelationshipsQueryVariables>(ChannelMeterRelationshipsDocument, options);
        }
export type ChannelMeterRelationshipsQueryHookResult = ReturnType<typeof useChannelMeterRelationshipsQuery>;
export type ChannelMeterRelationshipsLazyQueryHookResult = ReturnType<typeof useChannelMeterRelationshipsLazyQuery>;
export type ChannelMeterRelationshipsSuspenseQueryHookResult = ReturnType<typeof useChannelMeterRelationshipsSuspenseQuery>;
export type ChannelMeterRelationshipsQueryResult = Apollo.QueryResult<ChannelMeterRelationshipsQuery, ChannelMeterRelationshipsQueryVariables>;
export const GetOneCompositeChannelDocument = gql`
    query GetOneCompositeChannel($where: CompositeChannelGetOneInput!) {
  getOneCompositeChannel(where: $where) {
    id
    createdAt
    updatedAt
    name
    buildingId
    channelList
    period
    shadowId
    isDashboardDefault
    incomingUnit
  }
}
    `;

/**
 * __useGetOneCompositeChannelQuery__
 *
 * To run a query within a React component, call `useGetOneCompositeChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneCompositeChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneCompositeChannelQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetOneCompositeChannelQuery(baseOptions: Apollo.QueryHookOptions<GetOneCompositeChannelQuery, GetOneCompositeChannelQueryVariables> & ({ variables: GetOneCompositeChannelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneCompositeChannelQuery, GetOneCompositeChannelQueryVariables>(GetOneCompositeChannelDocument, options);
      }
export function useGetOneCompositeChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneCompositeChannelQuery, GetOneCompositeChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneCompositeChannelQuery, GetOneCompositeChannelQueryVariables>(GetOneCompositeChannelDocument, options);
        }
export function useGetOneCompositeChannelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneCompositeChannelQuery, GetOneCompositeChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneCompositeChannelQuery, GetOneCompositeChannelQueryVariables>(GetOneCompositeChannelDocument, options);
        }
export type GetOneCompositeChannelQueryHookResult = ReturnType<typeof useGetOneCompositeChannelQuery>;
export type GetOneCompositeChannelLazyQueryHookResult = ReturnType<typeof useGetOneCompositeChannelLazyQuery>;
export type GetOneCompositeChannelSuspenseQueryHookResult = ReturnType<typeof useGetOneCompositeChannelSuspenseQuery>;
export type GetOneCompositeChannelQueryResult = Apollo.QueryResult<GetOneCompositeChannelQuery, GetOneCompositeChannelQueryVariables>;
export const TargetsDocument = gql`
    query Targets($where: TargetGetManyInput!) {
  targets(where: $where) {
    id
    createdAt
    updatedAt
    name
    period
    benchmark
    channelId
    targetValue
    triggerCondition
    nextExpectedTime
    lastComparisonTime
    lastComparisonValue
  }
}
    `;

/**
 * __useTargetsQuery__
 *
 * To run a query within a React component, call `useTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTargetsQuery(baseOptions: Apollo.QueryHookOptions<TargetsQuery, TargetsQueryVariables> & ({ variables: TargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetsQuery, TargetsQueryVariables>(TargetsDocument, options);
      }
export function useTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetsQuery, TargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetsQuery, TargetsQueryVariables>(TargetsDocument, options);
        }
export function useTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TargetsQuery, TargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TargetsQuery, TargetsQueryVariables>(TargetsDocument, options);
        }
export type TargetsQueryHookResult = ReturnType<typeof useTargetsQuery>;
export type TargetsLazyQueryHookResult = ReturnType<typeof useTargetsLazyQuery>;
export type TargetsSuspenseQueryHookResult = ReturnType<typeof useTargetsSuspenseQuery>;
export type TargetsQueryResult = Apollo.QueryResult<TargetsQuery, TargetsQueryVariables>;
export const AlertsDocument = gql`
    query Alerts($where: AlertGetManyInput!) {
  alerts(where: $where) {
    id
    createdAt
    updatedAt
    userId
    targetId
    destination
    messageType
    severity
  }
}
    `;

/**
 * __useAlertsQuery__
 *
 * To run a query within a React component, call `useAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAlertsQuery(baseOptions: Apollo.QueryHookOptions<AlertsQuery, AlertsQueryVariables> & ({ variables: AlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
      }
export function useAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
        }
export function useAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
        }
export type AlertsQueryHookResult = ReturnType<typeof useAlertsQuery>;
export type AlertsLazyQueryHookResult = ReturnType<typeof useAlertsLazyQuery>;
export type AlertsSuspenseQueryHookResult = ReturnType<typeof useAlertsSuspenseQuery>;
export type AlertsQueryResult = Apollo.QueryResult<AlertsQuery, AlertsQueryVariables>;
export const BuildingGetManyDocument = gql`
    query BuildingGetMany($where: BuildingWhereUniqueSearchManyInput!) {
  buildingGetMany(where: $where) {
    id
    name
    defaultName
    projectRef
    slug
    picture
    thumb
    epcRating
    epcUrl
    breeamRating
    breeamScore
    constructionYear
    floorArea
    hasFileServer
    hasDataServer
    dashboardPeriod
    dashboardStyle
    lastSeen
    buildingTransmitting
    isOccupied
    isSubscribedDatalake
    isSubscribedOptitwin
    channelIssues {
      channelId
      lastSeen
      isImportant
      notTransmitting
      notCumulative
      includesZeroes
      isDisabled
    }
    mqttInfo {
      mqttUsername
      mqttPassword
    }
    uploadConfig {
      ftpConfig {
        id
        buildingId
        connectionType
        parser
      }
      mqttConfig {
        id
        buildingId
        connectionType
        host
        password
        port
        protocol
        topic
        useDefaultServer
        username
      }
    }
    companyRelationships {
      companyId
      companyName
      buildingName
      companyReference
      companyReferenceName
      relationshipType
    }
    address {
      buildingId
      companyId
      firstLine
      secondLine
      city
      region
      country
      postcode
      latitude
      longitude
      gasRegion
    }
    portfolio {
      renewables {
        measurement
        target
        unit
      }
      waterUsage {
        measurement
        target
        unit
      }
      carbonDioxide {
        measurement
        target
        unit
      }
      wholeBuilding {
        measurement
        target
        unit
      }
    }
  }
}
    `;

/**
 * __useBuildingGetManyQuery__
 *
 * To run a query within a React component, call `useBuildingGetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingGetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingGetManyQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBuildingGetManyQuery(baseOptions: Apollo.QueryHookOptions<BuildingGetManyQuery, BuildingGetManyQueryVariables> & ({ variables: BuildingGetManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingGetManyQuery, BuildingGetManyQueryVariables>(BuildingGetManyDocument, options);
      }
export function useBuildingGetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingGetManyQuery, BuildingGetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingGetManyQuery, BuildingGetManyQueryVariables>(BuildingGetManyDocument, options);
        }
export function useBuildingGetManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingGetManyQuery, BuildingGetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildingGetManyQuery, BuildingGetManyQueryVariables>(BuildingGetManyDocument, options);
        }
export type BuildingGetManyQueryHookResult = ReturnType<typeof useBuildingGetManyQuery>;
export type BuildingGetManyLazyQueryHookResult = ReturnType<typeof useBuildingGetManyLazyQuery>;
export type BuildingGetManySuspenseQueryHookResult = ReturnType<typeof useBuildingGetManySuspenseQuery>;
export type BuildingGetManyQueryResult = Apollo.QueryResult<BuildingGetManyQuery, BuildingGetManyQueryVariables>;
export const CompanyDocument = gql`
    query Company($where: CompanyWhereUnique!) {
  company(where: $where) {
    name
    portfolioImage
    slug
    logo
  }
}
    `;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables> & ({ variables: CompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export function useCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanySuspenseQueryHookResult = ReturnType<typeof useCompanySuspenseQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    token
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CheckResetTokenDocument = gql`
    query checkResetToken($where: String!) {
  checkResetToken(where: $where) {
    isValid
    email
  }
}
    `;

/**
 * __useCheckResetTokenQuery__
 *
 * To run a query within a React component, call `useCheckResetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckResetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckResetTokenQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCheckResetTokenQuery(baseOptions: Apollo.QueryHookOptions<CheckResetTokenQuery, CheckResetTokenQueryVariables> & ({ variables: CheckResetTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckResetTokenQuery, CheckResetTokenQueryVariables>(CheckResetTokenDocument, options);
      }
export function useCheckResetTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckResetTokenQuery, CheckResetTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckResetTokenQuery, CheckResetTokenQueryVariables>(CheckResetTokenDocument, options);
        }
export function useCheckResetTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckResetTokenQuery, CheckResetTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckResetTokenQuery, CheckResetTokenQueryVariables>(CheckResetTokenDocument, options);
        }
export type CheckResetTokenQueryHookResult = ReturnType<typeof useCheckResetTokenQuery>;
export type CheckResetTokenLazyQueryHookResult = ReturnType<typeof useCheckResetTokenLazyQuery>;
export type CheckResetTokenSuspenseQueryHookResult = ReturnType<typeof useCheckResetTokenSuspenseQuery>;
export type CheckResetTokenQueryResult = Apollo.QueryResult<CheckResetTokenQuery, CheckResetTokenQueryVariables>;
export const BuildingGetOneDocument = gql`
    query BuildingGetOne($where: BuildingWhereUniqueSearchOneInput!) {
  buildingGetOne(where: $where) {
    id
    name
    defaultName
    projectRef
    slug
    picture
    thumb
    epcRating
    epcUrl
    breeamRating
    breeamScore
    constructionYear
    floorArea
    hasFileServer
    hasDataServer
    dashboardPeriod
    dashboardStyle
    lastSeen
    buildingTransmitting
    tryMessage
    infoMessage
    isOccupied
    isSubscribedDatalake
    isSubscribedOptitwin
    channelIssues {
      channelId
      lastSeen
      isImportant
      notTransmitting
      notCumulative
      includesZeroes
      isDisabled
    }
    mqttInfo {
      mqttUsername
      mqttPassword
    }
    uploadConfig {
      ftpConfig {
        id
        buildingId
        connectionType
        parser
      }
      mqttConfig {
        id
        buildingId
        connectionType
        host
        password
        port
        protocol
        topic
        useDefaultServer
        username
      }
    }
    companyRelationships {
      companyId
      buildingId
      companyName
      buildingName
      companyReference
      companyReferenceName
      relationshipType
    }
    address {
      buildingId
      companyId
      firstLine
      secondLine
      city
      region
      country
      postcode
      latitude
      longitude
      gasRegion
    }
    portfolio {
      renewables {
        measurement
        target
        comment
        comparison
        unit
      }
      waterUsage {
        measurement
        target
        comment
        comparison
        unit
      }
      carbonDioxide {
        measurement
        target
        comment
        comparison
        unit
      }
      wholeBuilding {
        measurement
        target
        comment
        comparison
        unit
      }
      heatingEnergy {
        measurement
        target
        comment
        comparison
        unit
      }
      coolingEnergy {
        measurement
        target
        comment
        comparison
        unit
      }
      processEnergy {
        measurement
        target
        comment
        comparison
        unit
      }
      socketPower {
        measurement
        target
        comment
        comparison
        unit
      }
      lightingEnergy {
        measurement
        target
        comment
        comparison
        unit
      }
      ventilation {
        measurement
        target
        comment
        comparison
        unit
      }
    }
  }
}
    `;

/**
 * __useBuildingGetOneQuery__
 *
 * To run a query within a React component, call `useBuildingGetOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingGetOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingGetOneQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBuildingGetOneQuery(baseOptions: Apollo.QueryHookOptions<BuildingGetOneQuery, BuildingGetOneQueryVariables> & ({ variables: BuildingGetOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingGetOneQuery, BuildingGetOneQueryVariables>(BuildingGetOneDocument, options);
      }
export function useBuildingGetOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingGetOneQuery, BuildingGetOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingGetOneQuery, BuildingGetOneQueryVariables>(BuildingGetOneDocument, options);
        }
export function useBuildingGetOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingGetOneQuery, BuildingGetOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildingGetOneQuery, BuildingGetOneQueryVariables>(BuildingGetOneDocument, options);
        }
export type BuildingGetOneQueryHookResult = ReturnType<typeof useBuildingGetOneQuery>;
export type BuildingGetOneLazyQueryHookResult = ReturnType<typeof useBuildingGetOneLazyQuery>;
export type BuildingGetOneSuspenseQueryHookResult = ReturnType<typeof useBuildingGetOneSuspenseQuery>;
export type BuildingGetOneQueryResult = Apollo.QueryResult<BuildingGetOneQuery, BuildingGetOneQueryVariables>;
export const CompaniesDocument = gql`
    query Companies($where: CompanyWhereSearch!) {
  companies(where: $where) {
    id
    createdAt
    updatedAt
    name
    slug
    portfolioImage
    logo
    primaryColor
    secondaryColor
    fontColor
    userIds
  }
}
    `;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables> & ({ variables: CompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export function useCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesSuspenseQueryHookResult = ReturnType<typeof useCompaniesSuspenseQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const DataGetManyDocument = gql`
    query DataGetMany($where: DataInput!) {
  dataGetMany(where: $where) {
    id
    name
    unit
    data {
      id
      channelId
      timestamp
      value
      status
    }
  }
}
    `;

/**
 * __useDataGetManyQuery__
 *
 * To run a query within a React component, call `useDataGetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataGetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataGetManyQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDataGetManyQuery(baseOptions: Apollo.QueryHookOptions<DataGetManyQuery, DataGetManyQueryVariables> & ({ variables: DataGetManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataGetManyQuery, DataGetManyQueryVariables>(DataGetManyDocument, options);
      }
export function useDataGetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataGetManyQuery, DataGetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataGetManyQuery, DataGetManyQueryVariables>(DataGetManyDocument, options);
        }
export function useDataGetManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DataGetManyQuery, DataGetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataGetManyQuery, DataGetManyQueryVariables>(DataGetManyDocument, options);
        }
export type DataGetManyQueryHookResult = ReturnType<typeof useDataGetManyQuery>;
export type DataGetManyLazyQueryHookResult = ReturnType<typeof useDataGetManyLazyQuery>;
export type DataGetManySuspenseQueryHookResult = ReturnType<typeof useDataGetManySuspenseQuery>;
export type DataGetManyQueryResult = Apollo.QueryResult<DataGetManyQuery, DataGetManyQueryVariables>;
export const DashboardDocument = gql`
    query Dashboard($where: DashboardInput!) {
  dashboard(where: $where) {
    id
    createdAt
    updatedAt
    buildingId
    buildingName
    occupierLogo
    dashboardStyle
    renewables {
      measurement
      target
      comment
      comparison
      unit
    }
    carbonDioxide {
      measurement
      target
      comment
      comparison
      unit
    }
    waterUsage {
      measurement
      target
      comment
      comparison
      unit
    }
    wholeBuilding {
      measurement
      target
      comment
      comparison
      unit
    }
    ventilation {
      measurement
      target
      comment
      comparison
      unit
    }
    coolingEnergy {
      measurement
      target
      comment
      comparison
      unit
    }
    heatingEnergy {
      measurement
      target
      comment
      comparison
      unit
    }
    lightingEnergy {
      measurement
      target
      comment
      comparison
      unit
    }
    socketPower {
      measurement
      target
      comment
      comparison
      unit
    }
    processEnergy {
      measurement
      target
      comment
      comparison
      unit
    }
    period
    dashboardColors {
      primaryColor
      secondaryColor
      fontColor
    }
    tryMessage
    infoMessage
    currentConsumption
    currentGeneration
    lifetimeCarbonSavings
    lifetimeCarbonSavingsUnits
    address {
      companyId
      city
      postcode
      latitude
      longitude
    }
    weatherAPI {
      key
      host
    }
    transportAPI {
      id
      key
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDashboardQuery(baseOptions: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables> & ({ variables: DashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardSuspenseQueryHookResult = ReturnType<typeof useDashboardSuspenseQuery>;
export type DashboardQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const UserGetManyDocument = gql`
    query UserGetMany($where: UserGetManyInput!) {
  userGetMany(where: $where) {
    id
    createdAt
    updatedAt
    companyId
    email
    firstName
    lastName
    slug
    picture
    role
    customPermissions
  }
}
    `;

/**
 * __useUserGetManyQuery__
 *
 * To run a query within a React component, call `useUserGetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGetManyQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserGetManyQuery(baseOptions: Apollo.QueryHookOptions<UserGetManyQuery, UserGetManyQueryVariables> & ({ variables: UserGetManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGetManyQuery, UserGetManyQueryVariables>(UserGetManyDocument, options);
      }
export function useUserGetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGetManyQuery, UserGetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGetManyQuery, UserGetManyQueryVariables>(UserGetManyDocument, options);
        }
export function useUserGetManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGetManyQuery, UserGetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGetManyQuery, UserGetManyQueryVariables>(UserGetManyDocument, options);
        }
export type UserGetManyQueryHookResult = ReturnType<typeof useUserGetManyQuery>;
export type UserGetManyLazyQueryHookResult = ReturnType<typeof useUserGetManyLazyQuery>;
export type UserGetManySuspenseQueryHookResult = ReturnType<typeof useUserGetManySuspenseQuery>;
export type UserGetManyQueryResult = Apollo.QueryResult<UserGetManyQuery, UserGetManyQueryVariables>;
export const CompanyListDocument = gql`
    query CompanyList($where: CompanyWhereSearch!) {
  companies(where: $where) {
    id
    name
  }
}
    `;

/**
 * __useCompanyListQuery__
 *
 * To run a query within a React component, call `useCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCompanyListQuery(baseOptions: Apollo.QueryHookOptions<CompanyListQuery, CompanyListQueryVariables> & ({ variables: CompanyListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListQuery, CompanyListQueryVariables>(CompanyListDocument, options);
      }
export function useCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListQuery, CompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListQuery, CompanyListQueryVariables>(CompanyListDocument, options);
        }
export function useCompanyListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyListQuery, CompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyListQuery, CompanyListQueryVariables>(CompanyListDocument, options);
        }
export type CompanyListQueryHookResult = ReturnType<typeof useCompanyListQuery>;
export type CompanyListLazyQueryHookResult = ReturnType<typeof useCompanyListLazyQuery>;
export type CompanyListSuspenseQueryHookResult = ReturnType<typeof useCompanyListSuspenseQuery>;
export type CompanyListQueryResult = Apollo.QueryResult<CompanyListQuery, CompanyListQueryVariables>;
export const EmailBuildingOverviewDocument = gql`
    query EmailBuildingOverview($where: EmailBuildingOverviewInput!) {
  emailBuildingOverview(where: $where) {
    result
  }
}
    `;

/**
 * __useEmailBuildingOverviewQuery__
 *
 * To run a query within a React component, call `useEmailBuildingOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailBuildingOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailBuildingOverviewQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEmailBuildingOverviewQuery(baseOptions: Apollo.QueryHookOptions<EmailBuildingOverviewQuery, EmailBuildingOverviewQueryVariables> & ({ variables: EmailBuildingOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailBuildingOverviewQuery, EmailBuildingOverviewQueryVariables>(EmailBuildingOverviewDocument, options);
      }
export function useEmailBuildingOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailBuildingOverviewQuery, EmailBuildingOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailBuildingOverviewQuery, EmailBuildingOverviewQueryVariables>(EmailBuildingOverviewDocument, options);
        }
export function useEmailBuildingOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailBuildingOverviewQuery, EmailBuildingOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailBuildingOverviewQuery, EmailBuildingOverviewQueryVariables>(EmailBuildingOverviewDocument, options);
        }
export type EmailBuildingOverviewQueryHookResult = ReturnType<typeof useEmailBuildingOverviewQuery>;
export type EmailBuildingOverviewLazyQueryHookResult = ReturnType<typeof useEmailBuildingOverviewLazyQuery>;
export type EmailBuildingOverviewSuspenseQueryHookResult = ReturnType<typeof useEmailBuildingOverviewSuspenseQuery>;
export type EmailBuildingOverviewQueryResult = Apollo.QueryResult<EmailBuildingOverviewQuery, EmailBuildingOverviewQueryVariables>;
export const EmailFullBuildingDocument = gql`
    query EmailFullBuilding($where: EmailFullBuildingInput!) {
  emailFullBuilding(where: $where) {
    result
  }
}
    `;

/**
 * __useEmailFullBuildingQuery__
 *
 * To run a query within a React component, call `useEmailFullBuildingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailFullBuildingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailFullBuildingQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEmailFullBuildingQuery(baseOptions: Apollo.QueryHookOptions<EmailFullBuildingQuery, EmailFullBuildingQueryVariables> & ({ variables: EmailFullBuildingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailFullBuildingQuery, EmailFullBuildingQueryVariables>(EmailFullBuildingDocument, options);
      }
export function useEmailFullBuildingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailFullBuildingQuery, EmailFullBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailFullBuildingQuery, EmailFullBuildingQueryVariables>(EmailFullBuildingDocument, options);
        }
export function useEmailFullBuildingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailFullBuildingQuery, EmailFullBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailFullBuildingQuery, EmailFullBuildingQueryVariables>(EmailFullBuildingDocument, options);
        }
export type EmailFullBuildingQueryHookResult = ReturnType<typeof useEmailFullBuildingQuery>;
export type EmailFullBuildingLazyQueryHookResult = ReturnType<typeof useEmailFullBuildingLazyQuery>;
export type EmailFullBuildingSuspenseQueryHookResult = ReturnType<typeof useEmailFullBuildingSuspenseQuery>;
export type EmailFullBuildingQueryResult = Apollo.QueryResult<EmailFullBuildingQuery, EmailFullBuildingQueryVariables>;
export const GetManyCompositeChannelDocument = gql`
    query GetManyCompositeChannel($where: CompositeChannelGetManyInput!) {
  getManyCompositeChannel(where: $where) {
    id
    createdAt
    updatedAt
    name
    buildingId
    channelList
    period
    shadowId
    incomingUnit
  }
}
    `;

/**
 * __useGetManyCompositeChannelQuery__
 *
 * To run a query within a React component, call `useGetManyCompositeChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManyCompositeChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManyCompositeChannelQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetManyCompositeChannelQuery(baseOptions: Apollo.QueryHookOptions<GetManyCompositeChannelQuery, GetManyCompositeChannelQueryVariables> & ({ variables: GetManyCompositeChannelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManyCompositeChannelQuery, GetManyCompositeChannelQueryVariables>(GetManyCompositeChannelDocument, options);
      }
export function useGetManyCompositeChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManyCompositeChannelQuery, GetManyCompositeChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManyCompositeChannelQuery, GetManyCompositeChannelQueryVariables>(GetManyCompositeChannelDocument, options);
        }
export function useGetManyCompositeChannelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManyCompositeChannelQuery, GetManyCompositeChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManyCompositeChannelQuery, GetManyCompositeChannelQueryVariables>(GetManyCompositeChannelDocument, options);
        }
export type GetManyCompositeChannelQueryHookResult = ReturnType<typeof useGetManyCompositeChannelQuery>;
export type GetManyCompositeChannelLazyQueryHookResult = ReturnType<typeof useGetManyCompositeChannelLazyQuery>;
export type GetManyCompositeChannelSuspenseQueryHookResult = ReturnType<typeof useGetManyCompositeChannelSuspenseQuery>;
export type GetManyCompositeChannelQueryResult = Apollo.QueryResult<GetManyCompositeChannelQuery, GetManyCompositeChannelQueryVariables>;
export const InspectorGetOneDocument = gql`
    query InspectorGetOne($where: InspectorGetOneInput!) {
  inspectorGetOne(where: $where) {
    id
    createdAt
    updatedAt
    buildingId
    buildingLastSeen
    buildingTransmitting
    channels {
      lastSeen
      channelId
      isImportant
      notCumulative
      includesZeroes
      notTransmitting
      isDisabled
    }
  }
}
    `;

/**
 * __useInspectorGetOneQuery__
 *
 * To run a query within a React component, call `useInspectorGetOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectorGetOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectorGetOneQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useInspectorGetOneQuery(baseOptions: Apollo.QueryHookOptions<InspectorGetOneQuery, InspectorGetOneQueryVariables> & ({ variables: InspectorGetOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectorGetOneQuery, InspectorGetOneQueryVariables>(InspectorGetOneDocument, options);
      }
export function useInspectorGetOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectorGetOneQuery, InspectorGetOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectorGetOneQuery, InspectorGetOneQueryVariables>(InspectorGetOneDocument, options);
        }
export function useInspectorGetOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InspectorGetOneQuery, InspectorGetOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InspectorGetOneQuery, InspectorGetOneQueryVariables>(InspectorGetOneDocument, options);
        }
export type InspectorGetOneQueryHookResult = ReturnType<typeof useInspectorGetOneQuery>;
export type InspectorGetOneLazyQueryHookResult = ReturnType<typeof useInspectorGetOneLazyQuery>;
export type InspectorGetOneSuspenseQueryHookResult = ReturnType<typeof useInspectorGetOneSuspenseQuery>;
export type InspectorGetOneQueryResult = Apollo.QueryResult<InspectorGetOneQuery, InspectorGetOneQueryVariables>;
export const TargetAlertsGetManyDocument = gql`
    query TargetAlertsGetMany($where: TargetGetManyInput!) {
  targetAlertsGetMany(where: $where) {
    name
    benchmark
    channelId
    triggerCondition
    isDashboardDefault
    severity
    daily {
      targetId
      targetValue
      alertId
    }
    weekly {
      targetId
      targetValue
      alertId
    }
    monthly {
      targetId
      targetValue
      alertId
    }
    yearly {
      targetId
      targetValue
      alertId
    }
  }
}
    `;

/**
 * __useTargetAlertsGetManyQuery__
 *
 * To run a query within a React component, call `useTargetAlertsGetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetAlertsGetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetAlertsGetManyQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTargetAlertsGetManyQuery(baseOptions: Apollo.QueryHookOptions<TargetAlertsGetManyQuery, TargetAlertsGetManyQueryVariables> & ({ variables: TargetAlertsGetManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetAlertsGetManyQuery, TargetAlertsGetManyQueryVariables>(TargetAlertsGetManyDocument, options);
      }
export function useTargetAlertsGetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetAlertsGetManyQuery, TargetAlertsGetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetAlertsGetManyQuery, TargetAlertsGetManyQueryVariables>(TargetAlertsGetManyDocument, options);
        }
export function useTargetAlertsGetManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TargetAlertsGetManyQuery, TargetAlertsGetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TargetAlertsGetManyQuery, TargetAlertsGetManyQueryVariables>(TargetAlertsGetManyDocument, options);
        }
export type TargetAlertsGetManyQueryHookResult = ReturnType<typeof useTargetAlertsGetManyQuery>;
export type TargetAlertsGetManyLazyQueryHookResult = ReturnType<typeof useTargetAlertsGetManyLazyQuery>;
export type TargetAlertsGetManySuspenseQueryHookResult = ReturnType<typeof useTargetAlertsGetManySuspenseQuery>;
export type TargetAlertsGetManyQueryResult = Apollo.QueryResult<TargetAlertsGetManyQuery, TargetAlertsGetManyQueryVariables>;
export const GasCaloriesGetAllDocument = gql`
    query GasCaloriesGetAll {
  gasCaloriesGetAll {
    id
    country
    region
    date
    value
  }
}
    `;

/**
 * __useGasCaloriesGetAllQuery__
 *
 * To run a query within a React component, call `useGasCaloriesGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGasCaloriesGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGasCaloriesGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGasCaloriesGetAllQuery(baseOptions?: Apollo.QueryHookOptions<GasCaloriesGetAllQuery, GasCaloriesGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GasCaloriesGetAllQuery, GasCaloriesGetAllQueryVariables>(GasCaloriesGetAllDocument, options);
      }
export function useGasCaloriesGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GasCaloriesGetAllQuery, GasCaloriesGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GasCaloriesGetAllQuery, GasCaloriesGetAllQueryVariables>(GasCaloriesGetAllDocument, options);
        }
export function useGasCaloriesGetAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GasCaloriesGetAllQuery, GasCaloriesGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GasCaloriesGetAllQuery, GasCaloriesGetAllQueryVariables>(GasCaloriesGetAllDocument, options);
        }
export type GasCaloriesGetAllQueryHookResult = ReturnType<typeof useGasCaloriesGetAllQuery>;
export type GasCaloriesGetAllLazyQueryHookResult = ReturnType<typeof useGasCaloriesGetAllLazyQuery>;
export type GasCaloriesGetAllSuspenseQueryHookResult = ReturnType<typeof useGasCaloriesGetAllSuspenseQuery>;
export type GasCaloriesGetAllQueryResult = Apollo.QueryResult<GasCaloriesGetAllQuery, GasCaloriesGetAllQueryVariables>;
export const GasCarbonGetAllDocument = gql`
    query GasCarbonGetAll {
  gasCarbonGetAll {
    id
    country
    date
    value
  }
}
    `;

/**
 * __useGasCarbonGetAllQuery__
 *
 * To run a query within a React component, call `useGasCarbonGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGasCarbonGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGasCarbonGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGasCarbonGetAllQuery(baseOptions?: Apollo.QueryHookOptions<GasCarbonGetAllQuery, GasCarbonGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GasCarbonGetAllQuery, GasCarbonGetAllQueryVariables>(GasCarbonGetAllDocument, options);
      }
export function useGasCarbonGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GasCarbonGetAllQuery, GasCarbonGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GasCarbonGetAllQuery, GasCarbonGetAllQueryVariables>(GasCarbonGetAllDocument, options);
        }
export function useGasCarbonGetAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GasCarbonGetAllQuery, GasCarbonGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GasCarbonGetAllQuery, GasCarbonGetAllQueryVariables>(GasCarbonGetAllDocument, options);
        }
export type GasCarbonGetAllQueryHookResult = ReturnType<typeof useGasCarbonGetAllQuery>;
export type GasCarbonGetAllLazyQueryHookResult = ReturnType<typeof useGasCarbonGetAllLazyQuery>;
export type GasCarbonGetAllSuspenseQueryHookResult = ReturnType<typeof useGasCarbonGetAllSuspenseQuery>;
export type GasCarbonGetAllQueryResult = Apollo.QueryResult<GasCarbonGetAllQuery, GasCarbonGetAllQueryVariables>;
export const ElectricityCarbonGetAllDocument = gql`
    query ElectricityCarbonGetAll {
  electricityCarbonGetAll {
    id
    country
    date
    value
  }
}
    `;

/**
 * __useElectricityCarbonGetAllQuery__
 *
 * To run a query within a React component, call `useElectricityCarbonGetAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useElectricityCarbonGetAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useElectricityCarbonGetAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useElectricityCarbonGetAllQuery(baseOptions?: Apollo.QueryHookOptions<ElectricityCarbonGetAllQuery, ElectricityCarbonGetAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ElectricityCarbonGetAllQuery, ElectricityCarbonGetAllQueryVariables>(ElectricityCarbonGetAllDocument, options);
      }
export function useElectricityCarbonGetAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ElectricityCarbonGetAllQuery, ElectricityCarbonGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ElectricityCarbonGetAllQuery, ElectricityCarbonGetAllQueryVariables>(ElectricityCarbonGetAllDocument, options);
        }
export function useElectricityCarbonGetAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ElectricityCarbonGetAllQuery, ElectricityCarbonGetAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ElectricityCarbonGetAllQuery, ElectricityCarbonGetAllQueryVariables>(ElectricityCarbonGetAllDocument, options);
        }
export type ElectricityCarbonGetAllQueryHookResult = ReturnType<typeof useElectricityCarbonGetAllQuery>;
export type ElectricityCarbonGetAllLazyQueryHookResult = ReturnType<typeof useElectricityCarbonGetAllLazyQuery>;
export type ElectricityCarbonGetAllSuspenseQueryHookResult = ReturnType<typeof useElectricityCarbonGetAllSuspenseQuery>;
export type ElectricityCarbonGetAllQueryResult = Apollo.QueryResult<ElectricityCarbonGetAllQuery, ElectricityCarbonGetAllQueryVariables>;
export const DataGetManyInBinsDocument = gql`
    query DataGetManyInBins($where: DataInBinsInput!) {
  dataGetManyInBins(where: $where) {
    date
    bins {
      id
      timestamp
      value
      status
      channelId
    }
  }
}
    `;

/**
 * __useDataGetManyInBinsQuery__
 *
 * To run a query within a React component, call `useDataGetManyInBinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataGetManyInBinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataGetManyInBinsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDataGetManyInBinsQuery(baseOptions: Apollo.QueryHookOptions<DataGetManyInBinsQuery, DataGetManyInBinsQueryVariables> & ({ variables: DataGetManyInBinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataGetManyInBinsQuery, DataGetManyInBinsQueryVariables>(DataGetManyInBinsDocument, options);
      }
export function useDataGetManyInBinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataGetManyInBinsQuery, DataGetManyInBinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataGetManyInBinsQuery, DataGetManyInBinsQueryVariables>(DataGetManyInBinsDocument, options);
        }
export function useDataGetManyInBinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DataGetManyInBinsQuery, DataGetManyInBinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataGetManyInBinsQuery, DataGetManyInBinsQueryVariables>(DataGetManyInBinsDocument, options);
        }
export type DataGetManyInBinsQueryHookResult = ReturnType<typeof useDataGetManyInBinsQuery>;
export type DataGetManyInBinsLazyQueryHookResult = ReturnType<typeof useDataGetManyInBinsLazyQuery>;
export type DataGetManyInBinsSuspenseQueryHookResult = ReturnType<typeof useDataGetManyInBinsSuspenseQuery>;
export type DataGetManyInBinsQueryResult = Apollo.QueryResult<DataGetManyInBinsQuery, DataGetManyInBinsQueryVariables>;
export const BuildingGetAddressDocument = gql`
    query BuildingGetAddress($where: BuildingWhereUniqueSearchManyInput!) {
  buildingGetMany(where: $where) {
    id
    name
    address {
      buildingId
      postcode
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useBuildingGetAddressQuery__
 *
 * To run a query within a React component, call `useBuildingGetAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingGetAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingGetAddressQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBuildingGetAddressQuery(baseOptions: Apollo.QueryHookOptions<BuildingGetAddressQuery, BuildingGetAddressQueryVariables> & ({ variables: BuildingGetAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingGetAddressQuery, BuildingGetAddressQueryVariables>(BuildingGetAddressDocument, options);
      }
export function useBuildingGetAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingGetAddressQuery, BuildingGetAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingGetAddressQuery, BuildingGetAddressQueryVariables>(BuildingGetAddressDocument, options);
        }
export function useBuildingGetAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingGetAddressQuery, BuildingGetAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildingGetAddressQuery, BuildingGetAddressQueryVariables>(BuildingGetAddressDocument, options);
        }
export type BuildingGetAddressQueryHookResult = ReturnType<typeof useBuildingGetAddressQuery>;
export type BuildingGetAddressLazyQueryHookResult = ReturnType<typeof useBuildingGetAddressLazyQuery>;
export type BuildingGetAddressSuspenseQueryHookResult = ReturnType<typeof useBuildingGetAddressSuspenseQuery>;
export type BuildingGetAddressQueryResult = Apollo.QueryResult<BuildingGetAddressQuery, BuildingGetAddressQueryVariables>;
export const UserGetOneDocument = gql`
    query UserGetOne($where: UserGetOneInput!) {
  userGetOne(where: $where) {
    email
    firstName
    lastName
    picture
    id
    reporting {
      id
      userId
      portfolioEnabled
      portfolioPeriod
      buildings {
        buildingId
        buildingName
        buildingEnabled
        buildingPeriod
      }
    }
  }
}
    `;

/**
 * __useUserGetOneQuery__
 *
 * To run a query within a React component, call `useUserGetOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGetOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGetOneQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserGetOneQuery(baseOptions: Apollo.QueryHookOptions<UserGetOneQuery, UserGetOneQueryVariables> & ({ variables: UserGetOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGetOneQuery, UserGetOneQueryVariables>(UserGetOneDocument, options);
      }
export function useUserGetOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGetOneQuery, UserGetOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGetOneQuery, UserGetOneQueryVariables>(UserGetOneDocument, options);
        }
export function useUserGetOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGetOneQuery, UserGetOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGetOneQuery, UserGetOneQueryVariables>(UserGetOneDocument, options);
        }
export type UserGetOneQueryHookResult = ReturnType<typeof useUserGetOneQuery>;
export type UserGetOneLazyQueryHookResult = ReturnType<typeof useUserGetOneLazyQuery>;
export type UserGetOneSuspenseQueryHookResult = ReturnType<typeof useUserGetOneSuspenseQuery>;
export type UserGetOneQueryResult = Apollo.QueryResult<UserGetOneQuery, UserGetOneQueryVariables>;